// Auto-generated by scripts/prefetch-marketing-pages.mjs — DO NOT EDIT
// Generated at: 2026-09-04T12:29:58.641Z
export const COMPARISON_PAGE_SLUGS = ["topfan-vs-circle","topfan-vs-fanfix","topfan-vs-gumroad","topfan-vs-kajabi","topfan-vs-mighty","topfan-vs-passes","topfan-vs-patreon","topfan-vs-substack","topfan-vs-uscreen"] as const;

export const COMPARISON_PAGE_DATA: Record<string, any> = {
  "topfan-vs-circle": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "created_at": 1781873346135,
      "text_color": "#000000",
      "seoKeywords": "topfan vs circle, circle.so alternative, free community platform for creators, creator monetization platform, circle pricing comparison, community platform with monetization",
      "sequence_number": 4,
      "gsi1sk": "PAGE#1781873346135",
      "secondary_background_color": "#000000",
      "type": "MARKETING_COMPARISON",
      "button_text_color": "#ffffff",
      "meta_description": "Compare TopFan and Circle on pricing, monetization, and data ownership — see why creators choose a free platform over $89-419/month software.",
      "gsi1pk": "topfan-vs-circle",
      "background_text_color": "#ffffff",
      "meta_title": "TopFan vs Circle: Which is the better platform?",
      "page_id": 1781873346135,
      "updated_at": 1781873346135,
      "post_text_color": "#ffffff",
      "url": "topfan-vs-circle",
      "title": "Circle",
      "sk": "PAGE#1781873346135",
      "status": "PUBLISHED",
      "pk": "MARKETINGPAGE",
      "competitor_logo": "https://cdn-www7.topfans.dev/TopFans/Home1781760912888_frame_2147226363.png",
      "background_color": "#000000",
      "sections": [
        {
          "subheading": "TopFan is a creator-first platform helping you grow, engage, and earn through community, courses, and live experiences — completely free, with no $89–$419/month software fee like Circle charges.",
          "button_text_color": "#ffffff",
          "created_at": 1781873348526,
          "competitor_name": "Circle",
          "background_color": "#ffffff",
          "heading_font_size": "large",
          "background_text_color": "#000000",
          "theme_color": "#7c3aed",
          "name": "HERO PAGE",
          "platform_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780920210571_group.png",
          "background_image": null,
          "updated_at": 1781873348526,
          "page_id": 1781873346135,
          "post_text_color": "#000000",
          "layout_id": "comparison-hero-layout",
          "section_id": 1781873348526,
          "section_heading": "{TopFan vs Circle: Which is the better platform?}",
          "secondary_background_color": "#000000",
          "platform_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1781760932922_frame_2147226363.png",
          "pk": "PAGE#1781873346135",
          "title": "Hero Page",
          "sk": "SECTION#1781873348526"
        },
        {
          "subheading": "TopFans gives creators the tools to monetize, engage, grow, & manage their fan business.",
          "value_card_1_description": "Sell memberships, exclusive content, tips, paid DMs, merchandise, courses, and experiences from one platform.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "value_card_3_description": "Grow beyond social media with discovery tools, referrals, loyal fan rewards, and brand partnership opportunities.",
          "value_card_4_description": "Own your fan data, track content performance, manage access, and protect your content with built-in safety tools.",
          "name": "WHY CHOOSE TOPFAN",
          "page_id": 1781873346135,
          "value_card_2_title": "Deeper Fan Engagement",
          "section_heading": "{Why Choose TopFan?}",
          "value_card_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_message-chat-circle.png",
          "secondary_background_color": "#1f1f1e",
          "value_card_2_description": "Build stronger relationships through direct messages, polls, private communities, rewards, and personalized fan interactions.",
          "created_at": 1781873350890,
          "value_card_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-04.png",
          "heading_font_size": "medium",
          "value_card_4_title": "Full Control & Insights",
          "background_text_color": "#ffffff",
          "theme_color": "#5e00ff",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1780920467614_cb2078a3a11ac679ddb58d9cc8cf4c8bef941e9d__1_.png",
          "updated_at": 1781873350890,
          "post_text_color": "#ffffff",
          "layout_id": "comparison-value-grid-layout",
          "section_id": 1781873350890,
          "value_card_3_title": "Creator-Led Growth",
          "value_card_1_title": "More Ways to Earn",
          "value_card_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-03.png",
          "pk": "PAGE#1781873346135",
          "title": "WHY CHOOSE TOPFAN",
          "value_card_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_line-chart-up-03.png",
          "sk": "SECTION#1781873350890"
        },
        {
          "block_2_image_position": "left",
          "button_text_color": "#ffffff",
          "block_1_row_4_value_competitor": "Full Ownership",
          "background_color": "#ffffff",
          "block_4_row_1_feature": "Discovery Algorithm",
          "block_2_row_2_feature": "Tips on content & DMs",
          "block_4_row_1_value_competitor": "Not Available",
          "block_4_row_5_feature": "Loyalty Gamification",
          "block_3_row_1_value_topfan": "Media Selling",
          "block_3_row_2_value_topfan": "Audio Selling",
          "block_4_row_5_value_topfan": "Loyalty Tools",
          "block_4_row_4_value_topfan": "Supported",
          "block_2_row_2_value_topfan": "Tips Supported",
          "created_at": 1781873353260,
          "block_2_row_3_value_topfan": "Locked DMs",
          "block_1_row_3_value_topfan": "Custom URL",
          "block_3_row_3_feature": "Online Courses",
          "block_1_row_4_value_topfan": "Full Ownership",
          "block_1_row_2_value_competitor": "No Fan Fee",
          "block_1_heading": "Creator Setup & Control",
          "block_3_row_5_value_topfan": "Experience Selling",
          "layout_id": "comparison-feature-section-layout",
          "block_3_row_1_value_competitor": "Media Selling",
          "block_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__1_.png",
          "block_1_row_4_feature": "Fan Data Ownership",
          "subheading": "A full-stack online community platform designed for flexibility and scalability, empowering organizations to build, manage, and engage communities with ease.",
          "block_2_row_2_value_competitor": "Not Available",
          "block_4_row_4_feature": "Polls",
          "block_1_row_5_feature": "Publishing Scheduler",
          "block_2_row_1_feature": "Membership Tiers",
          "name": "COMMUNITY BUILDER",
          "page_id": 1781873346135,
          "block_1_image_position": "right",
          "section_heading": "{TopFan} is more than a Community Builder",
          "block_1_row_1_value_topfan": "5-15% plus standard 3rd party credit card fees",
          "block_2_row_5_feature": "Prize Giveaway",
          "block_4_row_1_value_topfan": "Built-in Discovery",
          "competitor_column_label": "Circle",
          "block_3_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_document-download.png",
          "block_2_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like.png",
          "block_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_content.png",
          "block_3_row_2_value_competitor": "Audio Selling",
          "block_4_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like__1_.png",
          "block_4_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_messages-2.png",
          "heading_font_size": "medium",
          "block_4_row_5_value_competitor": "Loyalty Tools",
          "block_3_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_musicnote.png",
          "block_1_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_receipt-2.png",
          "block_1_row_1_feature": "Creator Platform Fee",
          "theme_color": "#000000",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011790063_background_flare__1_.jpg",
          "post_text_color": "#000000",
          "block_2_heading": "Monetization & Selling",
          "block_3_row_4_feature": "Downloadable Content",
          "block_3_row_5_value_competitor": "Not Available",
          "block_2_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_star.png",
          "block_1_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_key.png",
          "block_4_row_2_value_competitor": "Limited ($99/month)",
          "block_4_row_3_feature": "Private Chat Rooms",
          "block_2_row_4_feature": "Shopify Supported",
          "block_1_row_3_value_competitor": "Not Available",
          "block_2_row_5_value_competitor": "Not Available",
          "topfan_column_label": "TopFan",
          "block_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__2_.png",
          "block_2_row_1_value_topfan": "Supported",
          "block_3_row_1_feature": "Videos & Galleries",
          "block_3_row_4_value_topfan": "Downloadable Selling",
          "block_4_row_2_value_topfan": "Supported",
          "block_1_row_2_value_topfan": "No Fan Fee",
          "block_4_row_3_value_topfan": "Supported",
          "block_3_row_3_value_topfan": "Course Selling",
          "block_4_row_4_value_competitor": "Supported",
          "block_4_description": "Build stronger fan relationships through interaction, discovery, and loyalty tools.",
          "block_2_row_4_value_topfan": "Supported",
          "background_text_color": "#000000",
          "block_3_description": "Sell different content formats from one creator storefront.",
          "block_1_description": "Set up, customize, and manage your creator presence with more ownership.",
          "block_2_row_5_value_topfan": "Giveaway Tools",
          "block_1_row_5_value_topfan": "Supported",
          "block_2_description": "Give creators more ways to earn through content, access, and fan purchases.",
          "updated_at": 1781873353260,
          "block_2_row_3_value_competitor": "Not Available",
          "block_1_row_2_feature": "Fan Platform Fee",
          "section_id": 1781873353260,
          "block_3_image_position": "right",
          "block_3_heading": "Content Commerce",
          "block_1_row_5_value_competitor": "Supported",
          "block_4_image_position": "left",
          "pk": "PAGE#1781873346135",
          "block_3_row_5_feature": "Experiences",
          "title": "COMMUNITY BUILDER",
          "block_4_row_2_feature": "Targeted Outreach",
          "block_3_row_4_value_competitor": "Limited",
          "block_3_row_3_value_competitor": "Supported",
          "block_2_row_3_feature": "Paid / Locked DMs",
          "secondary_background_color": "#000000",
          "block_2_row_1_value_competitor": "Supported",
          "block_3_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_teacher.png",
          "block_2_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_sms-star.png",
          "block_1_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_money.png",
          "block_2_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_crown.png",
          "block_4_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_shield-tick.png",
          "block_2_row_4_value_competitor": "Not Supported",
          "block_4_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_code-circle.png",
          "block_3_row_2_feature": "Audio & Music",
          "block_3_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gallery.png",
          "block_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__3_.png",
          "block_1_row_3_feature": "Custom Website URL",
          "block_4_row_3_value_competitor": "Supported",
          "block_1_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_send-2.png",
          "block_1_row_1_value_competitor": "$89–$419+/month software fee plus standard 3rd party credit card fees",
          "block_1_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_global.png",
          "block_2_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gift.png",
          "block_4_heading": "Fan Engagement & Growth",
          "block_4_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_coin.png",
          "block_3_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_flash.png",
          "sk": "SECTION#1781873353260"
        },
        {
          "subheading": "See how TopFans helps creators move beyond locked content with better control, wider monetization, and stronger fan-business tools.",
          "button_text_color": "#ffffff",
          "background_color": "#ffffff",
          "key_win_1_description": "TopFans gives creators custom URLs, fan data ownership, and stronger control over how they manage their fan business.",
          "key_win_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__2_.png",
          "key_win_5_title": "Engage Beyond Content Drops",
          "key_win_6_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__5_.png",
          "name": "WHERE TOPFAN WINS",
          "page_id": 1781873346135,
          "key_win_6_description": "TopFans supports creator growth through discovery, referrals, loyalty rewards, VIP access, brand opportunities, and advanced fan insights.",
          "key_win_5_description": "TopFans helps creators build stronger fan relationships through polls, private rooms, rewards, targeted messages, and paid interactions.",
          "key_win_4_title": "Own the Audience Relationship",
          "section_heading": "Where TopFan wins {over Circle}",
          "key_win_2_title": "Keep More From Every Sale",
          "key_win_3_description": "TopFans lets creators sell more than posts — including merchandise, courses, downloads, audio, experiences, and premium content collections.",
          "secondary_background_color": "#0f172a",
          "key_win_2_description": "TopFans offers a more creator-friendly fee structure, helping creators retain more value from memberships, paid content, and fan transactions.",
          "key_win_4_description": "With fan data ownership, segmentation, and export options, TopFans gives creators more control over their audience beyond the platform.",
          "key_win_6_title": "Built for Long-Term Growth",
          "created_at": 1781873355692,
          "heading_font_size": "medium",
          "background_text_color": "#1e293b",
          "key_win_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__3_.png",
          "theme_color": "#7c3aed",
          "key_win_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956730_featured_icon__1_.png",
          "key_win_1_title": "More Creator Control",
          "updated_at": 1781873355692,
          "key_win_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon.png",
          "post_text_color": "#000000",
          "layout_id": "comparison-key-wins-layout",
          "section_id": 1781873355692,
          "pk": "PAGE#1781873346135",
          "key_win_3_title": "Turn Fans Into Buyers",
          "title": "WHERE TOPFAN WINS",
          "key_win_5_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__4_.png",
          "sk": "SECTION#1781873355692"
        },
        {
          "button_text_color": "#ffffff",
          "row_5_value_2": "Limited Integration",
          "row_4_feature": "Block Users",
          "background_color": "#000000",
          "row_5_value_1": "Web3 Support",
          "row_7_value_2": "Not Available",
          "row_6_feature": "VIP access & ticketing",
          "row_7_value_1": "Hashtag Search",
          "row_1_value_1": "Advanced Insights",
          "row_1_value_2": "Advanced Insights",
          "row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_status-up.png",
          "row_3_value_1": "Available",
          "row_8_feature": "Fan Rewards",
          "row_3_value_2": "Not Available",
          "row_12_value_1": "243 Languages",
          "row_10_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_tag.png",
          "row_11_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_color-swatch.png",
          "created_at": 1781873358274,
          "row_11_feature": "Designer Access",
          "row_7_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_hashtag.png",
          "row_12_value_2": "Not Available",
          "row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_fi_6699366.png",
          "row_10_value_2": "Not Available",
          "column_2_label": "CIrcle",
          "row_6_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_ticket-star.png",
          "background_text_color": "#ffffff",
          "row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-security.png",
          "row_10_value_1": "Available",
          "row_13_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_convertshape-2.png",
          "row_12_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_language-circle.png",
          "row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_user-remove.png",
          "row_9_value_1": "Collab Tools",
          "updated_at": 1781873358274,
          "layout_id": "comparison-full-table-layout",
          "section_id": 1781873358274,
          "row_8_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_award.png",
          "row_9_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_share.png",
          "pk": "PAGE#1781873346135",
          "row_2_feature": "Security Watermarking",
          "row_9_value_2": "Limited",
          "title": "Other Advantages",
          "row_4_value_2": "User Blocking",
          "row_4_value_1": "User Blocking",
          "row_3_feature": "Stream Protection",
          "row_5_feature": "Web3 / NFT Integration",
          "name": "OTHER ADVANTAGES",
          "row_6_value_1": "VIP Tools",
          "row_6_value_2": "VIP Tools",
          "column_1_label": "TOPFAN",
          "page_id": 1781873346135,
          "row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-tick.png",
          "row_9_feature": "Creator Collaborations",
          "section_heading": "Other {Powerful TopFan} Advantages",
          "row_2_value_1": "Watermarking",
          "row_2_value_2": "Not Available",
          "secondary_background_color": "#000000",
          "row_7_feature": "Hashtag Organization",
          "row_13_feature": "Referral Program",
          "row_12_feature": "Auto Translation",
          "row_13_value_2": "Referral Program",
          "row_13_value_1": "Higher Rewards",
          "heading_font_size": "medium",
          "row_10_feature": "Brand Ads",
          "row_11_value_1": "Coming Soon",
          "theme_color": "#7c3aed",
          "row_11_value_2": "Not Available",
          "background_image": null,
          "post_text_color": "#ffffff",
          "row_8_value_2": "Rewards Supported",
          "row_8_value_1": "Rewards Supported",
          "row_1_feature": "Rich analytics",
          "section_subheading": "Additional tools that support safety, analytics, automation, and advanced creator workflows.",
          "sk": "SECTION#1781873358274"
        },
        {
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "name": "SUMMARY",
          "summary_heading": "Summary",
          "page_id": 1781873346135,
          "card_b_heading": "Who is CIrcle best suited for?",
          "secondary_background_color": "#f7f7f7",
          "created_at": 1781873360683,
          "summary_text": "While Circle focuses mainly on deep customization and tiered software pricing, TopFan is designed as a broader creator growth platform. TopFan gives creators more ways to earn, engage, and scale through memberships, content commerce, merchandise, courses, experiences, fan ownership, loyalty tools, and community-led growth — without Circle's $89–$419+/month bill or its stacked add-on fees",
          "heading_font_size": "medium",
          "card_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1781760949753_frame_2147226363.png",
          "card_a_body": "TopFan is built for creators who want to grow beyond exclusive content. Helps creators sell memberships, videos, courses, downloads, merchandise, experiences, and fan access from one platform. TopFan is best suited for creators and creator teams who want stronger fan ownership, deeper engagement, multiple revenue streams, and community-led growth.",
          "background_text_color": "#1b1b1b",
          "card_a_heading": "Who is TopFan best suited for?",
          "theme_color": "#7c3aed",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011777718_background_flare__1_.jpg",
          "updated_at": 1781873360683,
          "post_text_color": "#000000",
          "layout_id": "comparison-audience-summary-layout",
          "section_id": 1781873360683,
          "card_b_body": "Circle suits creators and brands running a polished, paid community business who don't mind a recurring software bill in exchange for deep customization — robust gamification, real analytics, and ticketed events. However, creators wanting free entry, a built-in storefront, or platform-driven discovery may need a more complete platform experience.",
          "pk": "PAGE#1781873346135",
          "card_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780922932705_group.png",
          "title": "SUMMARY",
          "sk": "SECTION#1781873360683"
        },
        {
          "button_text_color": "#ffffff",
          "testimonial_6_background_image": null,
          "background_color": "#d0e9ee",
          "testimonial_4_creator_type": "Professionals",
          "testimonial_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
          "testimonial_6_name": "The Predictors",
          "testimonial_2_user_name": "julia-kugel",
          "testimonial_6_creator_type": "Organizations",
          "testimonial_4_stars": "5",
          "testimonial_5_name": "Tulsa Bite",
          "testimonial_2_content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
          "testimonial_7_stars": "5",
          "testimonial_5_user_name": "tulsa_bite",
          "testimonial_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
          "testimonial_7_background_image": null,
          "testimonial_title": "Testimonials",
          "created_at": 1781873363333,
          "testimonial_4_background_image": null,
          "testimonial_5_stars": "5",
          "testimonial_1_user_name": "johnward",
          "background_text_color": "#000000",
          "testimonial_5_content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space.",
          "updated_at": 1781873363333,
          "testimonial_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
          "layout_id": "testimonial-layout",
          "section_id": 1781873363333,
          "testimonial_7_redirection_link": "https://www.markschlereth.fans/",
          "testimonial_1_stars": "5",
          "testimonial_4_user_name": "davidgold",
          "testimonial_2_redirection_link": "https://www.juliajulia.fans/",
          "pk": "PAGE#1781873346135",
          "testimonial_7_content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform.",
          "testimonial_5_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
          "title": "TESTIMONIALS",
          "testimonial_3_name": "Katrina Darling Friedman",
          "testimonial_7_user_name": "markschlereth",
          "testimonial_6_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
          "testimonial_5_creator_type": "Creator and Influencer",
          "testimonial_1_background_image": null,
          "testimonial_3_redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
          "name": "TESTIMONIALS",
          "testimonial_7_creator_type": "Athletes",
          "testimonial_3_user_name": "katrinadarlingfriedman",
          "testimonial_3_content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
          "page_id": 1781873346135,
          "testimonial_3_background_image": null,
          "section_heading": "More than {1,000} Creators Have Trusted Us Since We Started.",
          "testimonial_4_redirection_link": "https://www.goldweatherkingdom.com/",
          "testimonial_2_background_image": null,
          "testimonial_5_redirection_link": "https://www.topfan.com/tulsa_bite",
          "testimonial_1_content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
          "secondary_background_color": "#000000",
          "testimonial_2_stars": "5",
          "testimonial_2_name": "Julia Julia",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "johnward",
              "name": "John Ward",
              "redirection_link": "https://www.topfan.com/johnward",
              "stars": "5",
              "content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
              "creator_type": "Musicians",
              "user_name": "julia-kugel",
              "name": "Julia Julia",
              "redirection_link": "https://www.juliajulia.fans/",
              "stars": "5",
              "content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!"
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "katrinadarlingfriedman",
              "name": "Katrina Darling Friedman",
              "redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
              "stars": "5",
              "content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
              "creator_type": "Professionals",
              "user_name": "davidgold",
              "name": "David Gold",
              "redirection_link": "https://www.goldweatherkingdom.com/",
              "stars": "5",
              "content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
              "creator_type": "Creator and Influencer",
              "user_name": "tulsa_bite",
              "name": "Tulsa Bite",
              "redirection_link": "https://www.topfan.com/tulsa_bite",
              "stars": "5",
              "content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
              "creator_type": "Organizations",
              "user_name": "the-predictors",
              "name": "The Predictors",
              "redirection_link": "https://www.thepredictors.fans/",
              "stars": "5",
              "content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
              "creator_type": "Athletes",
              "user_name": "markschlereth",
              "name": "Mark Schlereth",
              "redirection_link": "https://www.markschlereth.fans/",
              "stars": "5",
              "content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform."
            }
          ],
          "testimonial_6_redirection_link": "https://www.thepredictors.fans/",
          "testimonial_6_user_name": "the-predictors",
          "testimonial_6_content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers.",
          "heading_font_size": "medium",
          "testimonial_1_redirection_link": "https://www.topfan.com/johnward",
          "testimonial_3_stars": "5",
          "testimonial_7_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
          "testimonial_1_name": "John Ward",
          "testimonial_4_content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.",
          "testimonial_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
          "theme_color": "#141515",
          "testimonial_5_background_image": null,
          "post_text_color": "#ffffff",
          "testimonial_6_stars": "5",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_4_name": "David Gold",
          "testimonial_1_creator_type": "Food, Fitness and Wellness",
          "testimonial_7_name": "Mark Schlereth",
          "testimonial_3_creator_type": "Food, Fitness and Wellness",
          "sk": "SECTION#1781873363333"
        }
      ]
    }
  },
  "topfan-vs-fanfix": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "sequence_number": 6,
      "background_text_color": "#ffffff",
      "url": "topfan-vs-fanfix",
      "meta_description": "Compare TopFan and FANFIX on branding, data ownership, and monetization tools — see why creators want their own platform, not Fanfix's.",
      "gsi1sk": "PAGE#1781873266454",
      "seoKeywords": "topfan vs fanfix, fanfix alternative, creator monetization platform, brand-safe creator platform, own branded fan platform, fanfix comparison",
      "pk": "MARKETINGPAGE",
      "button_text_color": "#ffffff",
      "status": "PUBLISHED",
      "background_color": "#000000",
      "title": "FANFIX",
      "updated_at": 1781873266454,
      "page_id": 1781873266454,
      "meta_title": "TopFan vs FANFIX: Which is the better platform?",
      "text_color": "#000000",
      "secondary_background_color": "#000000",
      "gsi1pk": "topfan-vs-fanfix",
      "post_text_color": "#ffffff",
      "competitor_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780989704056_frame_2147226362.png",
      "created_at": 1781873266454,
      "sk": "PAGE#1781873266454",
      "type": "MARKETING_COMPARISON",
      "sections": [
        {
          "subheading": "TopFan gives you a branded destination with subscriptions, exclusive content, live experiences, and full ownership of your audience data. FANFIX offers similar monetization tools, but your page lives on their platform, under their brand, with their rules.",
          "button_text_color": "#ffffff",
          "created_at": 1781873268905,
          "competitor_name": "Fanfix",
          "background_color": "#ffffff",
          "heading_font_size": "large",
          "background_text_color": "#000000",
          "theme_color": "#7c3aed",
          "name": "HERO PAGE",
          "platform_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780920210571_group.png",
          "background_image": null,
          "updated_at": 1781873268905,
          "page_id": 1781873266454,
          "post_text_color": "#000000",
          "layout_id": "comparison-hero-layout",
          "section_id": 1781873268905,
          "section_heading": "{TopFan vs FANFIX: Which is the better platform?}",
          "secondary_background_color": "#000000",
          "platform_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990597586_frame_2147226362.png",
          "pk": "PAGE#1781873266454",
          "title": "Hero Page",
          "sk": "SECTION#1781873268905"
        },
        {
          "subheading": "TopFans gives creators the tools to monetize, engage, grow, & manage their fan business.",
          "value_card_1_description": "Sell memberships, exclusive content, tips, paid DMs, merchandise, courses, and experiences from one platform.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "value_card_3_description": "Grow beyond social media with discovery tools, referrals, loyal fan rewards, and brand partnership opportunities.",
          "value_card_4_description": "Own your fan data, track content performance, manage access, and protect your content with built-in safety tools.",
          "name": "WHY CHOOSE TOPFAN",
          "page_id": 1781873266454,
          "value_card_2_title": "Deeper Fan Engagement",
          "section_heading": "{Why Choose TopFan?}",
          "value_card_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_message-chat-circle.png",
          "secondary_background_color": "#1f1f1e",
          "value_card_2_description": "Build stronger relationships through direct messages, polls, private communities, rewards, and personalized fan interactions.",
          "created_at": 1781873271406,
          "value_card_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-04.png",
          "heading_font_size": "medium",
          "value_card_4_title": "Full Control & Insights",
          "background_text_color": "#ffffff",
          "theme_color": "#5e00ff",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1780920467614_cb2078a3a11ac679ddb58d9cc8cf4c8bef941e9d__1_.png",
          "updated_at": 1781873271406,
          "post_text_color": "#ffffff",
          "layout_id": "comparison-value-grid-layout",
          "section_id": 1781873271406,
          "value_card_3_title": "Creator-Led Growth",
          "value_card_1_title": "More Ways to Earn",
          "value_card_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-03.png",
          "pk": "PAGE#1781873266454",
          "title": "WHY CHOOSE TOPFAN",
          "value_card_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_line-chart-up-03.png",
          "sk": "SECTION#1781873271406"
        },
        {
          "block_2_image_position": "left",
          "button_text_color": "#ffffff",
          "block_1_row_4_value_competitor": "Limited Control",
          "background_color": "#ffffff",
          "block_4_row_1_feature": "Discovery Algorithm",
          "block_2_row_2_feature": "Tips on content & DMs",
          "block_4_row_1_value_competitor": "Not Available",
          "block_4_row_5_feature": "Loyalty Gamification",
          "block_3_row_1_value_topfan": "Media Selling",
          "block_3_row_2_value_topfan": "Audio Selling",
          "block_4_row_5_value_topfan": "Loyalty Tools",
          "block_4_row_4_value_topfan": "Supported",
          "block_2_row_2_value_topfan": "Tips Supported",
          "created_at": 1781873273885,
          "block_2_row_3_value_topfan": "Locked DMs",
          "block_1_row_3_value_topfan": "Custom URL",
          "block_3_row_3_feature": "Online Courses",
          "block_1_row_4_value_topfan": "Full Ownership",
          "block_1_row_2_value_competitor": "No Fan Fee",
          "block_1_heading": "Creator Setup & Control",
          "block_3_row_5_value_topfan": "Experience Selling",
          "layout_id": "comparison-feature-section-layout",
          "block_3_row_1_value_competitor": "Media Selling",
          "block_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__1_.png",
          "block_1_row_4_feature": "Fan Data Ownership",
          "subheading": "A full-stack online community platform designed for flexibility and scalability, empowering organizations to build, manage, and engage communities with ease.",
          "block_2_row_2_value_competitor": "Tips Supported",
          "block_4_row_4_feature": "Polls",
          "block_1_row_5_feature": "Publishing Scheduler",
          "block_2_row_1_feature": "Membership Tiers",
          "name": "COMMUNITY BUILDER",
          "page_id": 1781873266454,
          "block_1_image_position": "right",
          "section_heading": "{TopFan} is more than a Community Builder",
          "block_1_row_1_value_topfan": "5-15% plus standard 3rd party credit card fees",
          "block_2_row_5_feature": "Prize Giveaway",
          "block_4_row_1_value_topfan": "Built-in Discovery",
          "competitor_column_label": "FANFIX",
          "block_3_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_document-download.png",
          "block_2_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like.png",
          "block_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_content.png",
          "block_3_row_2_value_competitor": "Audio Selling",
          "block_4_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like__1_.png",
          "block_4_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_messages-2.png",
          "heading_font_size": "medium",
          "block_4_row_5_value_competitor": "Not Available",
          "block_3_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_musicnote.png",
          "block_1_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_receipt-2.png",
          "block_1_row_1_feature": "Creator Platform Fee",
          "theme_color": "#000000",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011603708_background_flare__1_.jpg",
          "post_text_color": "#000000",
          "block_2_heading": "Monetization & Selling",
          "block_3_row_4_feature": "Downloadable Content",
          "block_3_row_5_value_competitor": "Not Available",
          "block_2_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_star.png",
          "block_1_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_key.png",
          "block_4_row_2_value_competitor": "Not Available",
          "block_4_row_3_feature": "Private Chat Rooms",
          "block_2_row_4_feature": "Shopify Supported",
          "block_1_row_3_value_competitor": "Not Available",
          "block_2_row_5_value_competitor": "Not Available",
          "topfan_column_label": "TopFan",
          "block_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__2_.png",
          "block_2_row_1_value_topfan": "Supported",
          "block_3_row_1_feature": "Videos & Galleries",
          "block_3_row_4_value_topfan": "Downloadable Selling",
          "block_4_row_2_value_topfan": "Supported",
          "block_1_row_2_value_topfan": "No Fan Fee",
          "block_4_row_3_value_topfan": "Supported",
          "block_3_row_3_value_topfan": "Course Selling",
          "block_4_row_4_value_competitor": "Supported",
          "block_4_description": "Build stronger fan relationships through interaction, discovery, and loyalty tools.",
          "block_2_row_4_value_topfan": "Supported",
          "background_text_color": "#000000",
          "block_3_description": "Sell different content formats from one creator storefront.",
          "block_1_description": "Set up, customize, and manage your creator presence with more ownership.",
          "block_2_row_5_value_topfan": "Giveaway Tools",
          "block_1_row_5_value_topfan": "Supported",
          "block_2_description": "Give creators more ways to earn through content, access, and fan purchases.",
          "updated_at": 1781873273885,
          "block_2_row_3_value_competitor": "Locked DMs",
          "block_1_row_2_feature": "Fan Platform Fee",
          "section_id": 1781873273885,
          "block_3_image_position": "right",
          "block_3_heading": "Content Commerce",
          "block_1_row_5_value_competitor": "Supported",
          "block_4_image_position": "left",
          "pk": "PAGE#1781873266454",
          "block_3_row_5_feature": "Experiences",
          "title": "COMMUNITY BUILDER",
          "block_4_row_2_feature": "Targeted Outreach",
          "block_3_row_4_value_competitor": "Not Available",
          "block_3_row_3_value_competitor": "Not Available",
          "block_2_row_3_feature": "Paid / Locked DMs",
          "secondary_background_color": "#000000",
          "block_2_row_1_value_competitor": "Supported",
          "block_3_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_teacher.png",
          "block_2_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_sms-star.png",
          "block_1_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_money.png",
          "block_2_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_crown.png",
          "block_4_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_shield-tick.png",
          "block_2_row_4_value_competitor": "Not Supported",
          "block_4_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_code-circle.png",
          "block_3_row_2_feature": "Audio & Music",
          "block_3_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gallery.png",
          "block_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__3_.png",
          "block_1_row_3_feature": "Custom Website URL",
          "block_4_row_3_value_competitor": "Not Supported",
          "block_1_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_send-2.png",
          "block_1_row_1_value_competitor": "20% Fee",
          "block_1_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_global.png",
          "block_2_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gift.png",
          "block_4_heading": "Fan Engagement & Growth",
          "block_4_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_coin.png",
          "block_3_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_flash.png",
          "sk": "SECTION#1781873273885"
        },
        {
          "subheading": "See how TopFans helps creators move beyond locked content with better control, wider monetization, and stronger fan-business tools.",
          "button_text_color": "#ffffff",
          "background_color": "#ffffff",
          "key_win_1_description": "TopFans gives creators custom URLs, fan data ownership, and stronger control over how they manage their fan business.",
          "key_win_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__2_.png",
          "key_win_5_title": "Engage Beyond Content Drops",
          "key_win_6_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__5_.png",
          "name": "WHERE TOPFAN WINS",
          "page_id": 1781873266454,
          "key_win_6_description": "TopFans supports creator growth through discovery, referrals, loyalty rewards, VIP access, brand opportunities, and advanced fan insights.",
          "key_win_5_description": "TopFans helps creators build stronger fan relationships through polls, private rooms, rewards, targeted messages, and paid interactions.",
          "key_win_4_title": "Own the Audience Relationship",
          "section_heading": "Where TopFan wins {over FANFIX}",
          "key_win_2_title": "Keep More From Every Sale",
          "key_win_3_description": "TopFans lets creators sell more than posts — including merchandise, courses, downloads, audio, experiences, and premium content collections.",
          "secondary_background_color": "#0f172a",
          "key_win_2_description": "TopFans offers a more creator-friendly fee structure, helping creators retain more value from memberships, paid content, and fan transactions.",
          "key_win_4_description": "With fan data ownership, segmentation, and export options, TopFans gives creators more control over their audience beyond the platform.",
          "key_win_6_title": "Built for Long-Term Growth",
          "created_at": 1781873276342,
          "heading_font_size": "medium",
          "background_text_color": "#1e293b",
          "key_win_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__3_.png",
          "theme_color": "#7c3aed",
          "key_win_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956730_featured_icon__1_.png",
          "key_win_1_title": "More Creator Control",
          "updated_at": 1781873276342,
          "key_win_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon.png",
          "post_text_color": "#000000",
          "layout_id": "comparison-key-wins-layout",
          "section_id": 1781873276342,
          "pk": "PAGE#1781873266454",
          "key_win_3_title": "Turn Fans Into Buyers",
          "title": "WHERE TOPFAN WINS",
          "key_win_5_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__4_.png",
          "sk": "SECTION#1781873276342"
        },
        {
          "button_text_color": "#ffffff",
          "row_5_value_2": "Not Available",
          "row_4_feature": "Block Users",
          "background_color": "#000000",
          "row_5_value_1": "Web3 Support",
          "row_7_value_2": "Not Available",
          "row_6_feature": "VIP access & ticketing",
          "row_7_value_1": "Hashtag Search",
          "row_1_value_1": "Advanced Insights",
          "row_1_value_2": "Basic Insights",
          "row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_status-up.png",
          "row_3_value_1": "Available",
          "row_8_feature": "Fan Rewards",
          "row_3_value_2": "Available",
          "row_12_value_1": "243 Languages",
          "row_10_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_tag.png",
          "row_11_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_color-swatch.png",
          "created_at": 1781873278733,
          "row_11_feature": "Designer Access",
          "row_7_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_hashtag.png",
          "row_12_value_2": "Not Available",
          "row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_fi_6699366.png",
          "row_10_value_2": "Not Available",
          "column_2_label": "FANFIX",
          "row_6_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_ticket-star.png",
          "background_text_color": "#ffffff",
          "row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-security.png",
          "row_10_value_1": "Available",
          "row_13_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_convertshape-2.png",
          "row_12_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_language-circle.png",
          "row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_user-remove.png",
          "row_9_value_1": "Collab Tools",
          "updated_at": 1781873278733,
          "layout_id": "comparison-full-table-layout",
          "section_id": 1781873278733,
          "row_8_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_award.png",
          "row_9_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_share.png",
          "pk": "PAGE#1781873266454",
          "row_2_feature": "Security Watermarking",
          "row_9_value_2": "Not Available",
          "title": "Other Advantages",
          "row_4_value_2": "Available",
          "row_4_value_1": "User Blocking",
          "row_3_feature": "Stream Protection",
          "row_5_feature": "Web3 / NFT Integration",
          "name": "OTHER ADVANTAGES",
          "row_6_value_1": "VIP Tools",
          "row_6_value_2": "Not Available",
          "column_1_label": "TOPFAN",
          "page_id": 1781873266454,
          "row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-tick.png",
          "row_9_feature": "Creator Collaborations",
          "section_heading": "Other {Powerful TopFan} Advantages",
          "row_2_value_1": "Watermarking",
          "row_2_value_2": "Available",
          "secondary_background_color": "#000000",
          "row_7_feature": "Hashtag Organization",
          "row_13_feature": "Referral Program",
          "row_12_feature": "Auto Translation",
          "row_13_value_2": "Available",
          "row_13_value_1": "Higher Rewards",
          "heading_font_size": "medium",
          "row_10_feature": "Brand Ads",
          "row_11_value_1": "Coming Soon",
          "theme_color": "#7c3aed",
          "row_11_value_2": "Not Available",
          "background_image": null,
          "post_text_color": "#ffffff",
          "row_8_value_2": "Not Available",
          "row_8_value_1": "Rewards Supported",
          "row_1_feature": "Rich analytics",
          "section_subheading": "Additional tools that support safety, analytics, automation, and advanced creator workflows.",
          "sk": "SECTION#1781873278733"
        },
        {
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "name": "SUMMARY",
          "summary_heading": "Summary",
          "page_id": 1781873266454,
          "card_b_heading": "Who is FANFIX best suited for?",
          "secondary_background_color": "#f7f7f7",
          "created_at": 1781873281158,
          "summary_text": "While FANFIX offers a straightforward subscription model for content monetization, it operates as a closed platform — your page lives on Fanfix's domain, under their brand, with their rules. TopFan is built differently. It gives creators a fully branded destination they actually own, with more ways to earn through subscriptions, courses, downloadable content, experiences, and merchandise — plus full fan data ownership, loyalty tools, and community-led growth built in from day one.",
          "heading_font_size": "medium",
          "card_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990639447_frame_2147226362.png",
          "card_a_body": "TopFan is built for creators who want to grow beyond exclusive content. Helps creators sell memberships, videos, courses, downloads, merchandise, experiences, and fan access from one platform. TopFan is best suited for creators and creator teams who want stronger fan ownership, deeper engagement, multiple revenue streams, and community-led growth.",
          "background_text_color": "#1b1b1b",
          "card_a_heading": "Who is TopFan best suited for?",
          "theme_color": "#7c3aed",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011619765_background_flare__1_.jpg",
          "updated_at": 1781873281158,
          "post_text_color": "#000000",
          "layout_id": "comparison-audience-summary-layout",
          "section_id": 1781873281158,
          "card_b_body": "FANFIX is best suited for influencers who want a simple, fast way to monetize an existing social following through subscriptions and locked content. It works well for creators who don't need brand control, don't require a custom domain, and are comfortable with Fanfix owning their audience data. Creators looking to sell courses, downloadable content, or experiences, build a branded community, or scale beyond basic fan subscriptions will find Fanfix limiting.",
          "pk": "PAGE#1781873266454",
          "card_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780922932705_group.png",
          "title": "SUMMARY",
          "sk": "SECTION#1781873281158"
        },
        {
          "button_text_color": "#ffffff",
          "testimonial_6_background_image": null,
          "background_color": "#d0e9ee",
          "testimonial_4_creator_type": "Professionals",
          "testimonial_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
          "testimonial_6_name": "The Predictors",
          "testimonial_2_user_name": "julia-kugel",
          "testimonial_6_creator_type": "Organizations",
          "testimonial_4_stars": "5",
          "testimonial_5_name": "Tulsa Bite",
          "testimonial_2_content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
          "testimonial_7_stars": "5",
          "testimonial_5_user_name": "tulsa_bite",
          "testimonial_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
          "testimonial_7_background_image": null,
          "testimonial_title": "Testimonials",
          "created_at": 1781873284198,
          "testimonial_4_background_image": null,
          "testimonial_5_stars": "5",
          "testimonial_1_user_name": "johnward",
          "background_text_color": "#000000",
          "testimonial_5_content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space.",
          "updated_at": 1781873284198,
          "testimonial_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
          "layout_id": "testimonial-layout",
          "section_id": 1781873284198,
          "testimonial_7_redirection_link": "https://www.markschlereth.fans/",
          "testimonial_1_stars": "5",
          "testimonial_4_user_name": "davidgold",
          "testimonial_2_redirection_link": "https://www.juliajulia.fans/",
          "pk": "PAGE#1781873266454",
          "is_visible": false,
          "testimonial_7_content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform.",
          "testimonial_5_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
          "title": "TESTIMONIALS",
          "testimonial_3_name": "Katrina Darling Friedman",
          "testimonial_7_user_name": "markschlereth",
          "testimonial_6_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
          "testimonial_5_creator_type": "Creator and Influencer",
          "testimonial_1_background_image": null,
          "testimonial_3_redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
          "name": "TESTIMONIALS",
          "testimonial_7_creator_type": "Athletes",
          "testimonial_3_user_name": "katrinadarlingfriedman",
          "testimonial_3_content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
          "page_id": 1781873266454,
          "testimonial_3_background_image": null,
          "section_heading": "More than {1,000} Creators Have Trusted Us Since We Started.",
          "testimonial_4_redirection_link": "https://www.goldweatherkingdom.com/",
          "testimonial_2_background_image": null,
          "testimonial_5_redirection_link": "https://www.topfan.com/tulsa_bite",
          "testimonial_1_content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
          "secondary_background_color": "#000000",
          "testimonial_2_stars": "5",
          "testimonial_2_name": "Julia Julia",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "johnward",
              "name": "John Ward",
              "redirection_link": "https://www.topfan.com/johnward",
              "stars": "5",
              "content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
              "creator_type": "Musicians",
              "user_name": "julia-kugel",
              "name": "Julia Julia",
              "redirection_link": "https://www.juliajulia.fans/",
              "stars": "5",
              "content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!"
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "katrinadarlingfriedman",
              "name": "Katrina Darling Friedman",
              "redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
              "stars": "5",
              "content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
              "creator_type": "Professionals",
              "user_name": "davidgold",
              "name": "David Gold",
              "redirection_link": "https://www.goldweatherkingdom.com/",
              "stars": "5",
              "content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
              "creator_type": "Creator and Influencer",
              "user_name": "tulsa_bite",
              "name": "Tulsa Bite",
              "redirection_link": "https://www.topfan.com/tulsa_bite",
              "stars": "5",
              "content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
              "creator_type": "Organizations",
              "user_name": "the-predictors",
              "name": "The Predictors",
              "redirection_link": "https://www.thepredictors.fans/",
              "stars": "5",
              "content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
              "creator_type": "Athletes",
              "user_name": "markschlereth",
              "name": "Mark Schlereth",
              "redirection_link": "https://www.markschlereth.fans/",
              "stars": "5",
              "content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform."
            }
          ],
          "testimonial_6_redirection_link": "https://www.thepredictors.fans/",
          "testimonial_6_user_name": "the-predictors",
          "testimonial_6_content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers.",
          "heading_font_size": "medium",
          "testimonial_1_redirection_link": "https://www.topfan.com/johnward",
          "testimonial_3_stars": "5",
          "testimonial_7_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
          "testimonial_1_name": "John Ward",
          "testimonial_4_content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.",
          "testimonial_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
          "theme_color": "#141515",
          "testimonial_5_background_image": null,
          "post_text_color": "#ffffff",
          "testimonial_6_stars": "5",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_4_name": "David Gold",
          "testimonial_1_creator_type": "Food, Fitness and Wellness",
          "testimonial_7_name": "Mark Schlereth",
          "testimonial_3_creator_type": "Food, Fitness and Wellness",
          "sk": "SECTION#1781873284198"
        }
      ]
    }
  },
  "topfan-vs-gumroad": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "gsi1pk": "topfan-vs-gumroad",
      "seoKeywords": "topfan vs passes, passes app alternative, creator monetization platform, own branded fan platform, passes pricing comparison, creator accelerator alternative",
      "meta_description": "Compare TopFan and Passes on fees, branding, and fan data ownership.",
      "competitor_logo": "https://cdn-www7.topfans.dev/TopFans/Home1781850764245_gumroad.png",
      "post_text_color": "#ffffff",
      "background_color": "#000000",
      "status": "PUBLISHED",
      "pk": "MARKETINGPAGE",
      "page_id": 1781872646064,
      "sk": "PAGE#1781872646064",
      "sequence_number": 9,
      "updated_at": 1781872646064,
      "secondary_background_color": "#000000",
      "meta_title": "TopFan vs Gumroad: Which Is the Better Platform in 2026?",
      "url": "topfan-vs-gumroad",
      "background_text_color": "#ffffff",
      "text_color": "#000000",
      "gsi1sk": "PAGE#1781872646064",
      "button_text_color": "#ffffff",
      "created_at": 1781872646064,
      "title": "GUMROAD",
      "type": "MARKETING_COMPARISON",
      "sections": [
        {
          "subheading": "A creator-first platform helping you grow, engage, and earn through subscriptions, content, and live experiences — all on your own branded site and app, not Passes'.",
          "button_text_color": "#ffffff",
          "created_at": 1781872648479,
          "competitor_name": "Gumroad",
          "background_color": "#ffffff",
          "heading_font_size": "large",
          "background_text_color": "#000000",
          "theme_color": "#7c3aed",
          "name": "HERO PAGE",
          "platform_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780920210571_group.png",
          "background_image": null,
          "updated_at": 1781872648479,
          "page_id": 1781872646064,
          "post_text_color": "#000000",
          "layout_id": "comparison-hero-layout",
          "section_id": 1781872648479,
          "section_heading": "{TopFan vs Gumroad: Which is the better platform?}",
          "secondary_background_color": "#000000",
          "platform_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1781850664741_gumroad.png",
          "pk": "PAGE#1781872646064",
          "title": "Hero Page",
          "sk": "SECTION#1781872648479"
        },
        {
          "subheading": "TopFans gives creators the tools to monetize, engage, grow, & manage their fan business.",
          "value_card_1_description": "Sell memberships, exclusive content, tips, paid DMs, merchandise, courses, and experiences from one platform.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "value_card_3_description": "Grow beyond social media with discovery tools, referrals, loyal fan rewards, and brand partnership opportunities.",
          "value_card_4_description": "Own your fan data, track content performance, manage access, and protect your content with built-in safety tools.",
          "name": "WHY CHOOSE TOPFAN",
          "page_id": 1781872646064,
          "value_card_2_title": "Deeper Fan Engagement",
          "section_heading": "{Why Choose TopFan?}",
          "value_card_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_message-chat-circle.png",
          "secondary_background_color": "#1f1f1e",
          "value_card_2_description": "Build stronger relationships through direct messages, polls, private communities, rewards, and personalized fan interactions.",
          "created_at": 1781872650865,
          "value_card_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-04.png",
          "heading_font_size": "medium",
          "value_card_4_title": "Full Control & Insights",
          "background_text_color": "#ffffff",
          "theme_color": "#5e00ff",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1780920467614_cb2078a3a11ac679ddb58d9cc8cf4c8bef941e9d__1_.png",
          "updated_at": 1781872650865,
          "post_text_color": "#ffffff",
          "layout_id": "comparison-value-grid-layout",
          "section_id": 1781872650865,
          "value_card_3_title": "Creator-Led Growth",
          "value_card_1_title": "More Ways to Earn",
          "value_card_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-03.png",
          "pk": "PAGE#1781872646064",
          "title": "WHY CHOOSE TOPFAN",
          "value_card_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_line-chart-up-03.png",
          "sk": "SECTION#1781872650865"
        },
        {
          "block_2_image_position": "left",
          "button_text_color": "#ffffff",
          "block_1_row_4_value_competitor": "Limited Control",
          "background_color": "#ffffff",
          "block_4_row_1_feature": "Discovery Algorithm",
          "block_2_row_2_feature": "Tips on content & DMs",
          "block_4_row_1_value_competitor": "Built-in Discovery",
          "block_4_row_5_feature": "Loyalty Gamification",
          "block_3_row_1_value_topfan": "Media Selling",
          "block_3_row_2_value_topfan": "Audio Selling",
          "block_4_row_5_value_topfan": "Loyalty Tools",
          "block_4_row_4_value_topfan": "Supported",
          "block_2_row_2_value_topfan": "Tips Supported",
          "created_at": 1781872653327,
          "block_2_row_3_value_topfan": "Locked DMs",
          "block_1_row_3_value_topfan": "Custom URL",
          "block_3_row_3_feature": "Online Courses",
          "block_1_row_4_value_topfan": "Full Ownership",
          "block_1_row_2_value_competitor": "No Fan Fee",
          "block_1_heading": "Creator Setup & Control",
          "block_3_row_5_value_topfan": "Experiences Selling",
          "layout_id": "comparison-feature-section-layout",
          "block_3_row_1_value_competitor": "Media Selling",
          "block_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__1_.png",
          "block_1_row_4_feature": "Fan Data Ownership",
          "subheading": "A full-stack online community platform designed for flexibility and scalability, empowering organizations to build, manage, and engage communities with ease.",
          "block_2_row_2_value_competitor": "Tips Supported",
          "block_4_row_4_feature": "Polls",
          "block_1_row_5_feature": "Publishing Scheduler",
          "block_2_row_1_feature": "Membership Tiers",
          "name": "COMMUNITY BUILDER",
          "page_id": 1781872646064,
          "block_1_image_position": "right",
          "section_heading": "{TopFan} is more than a Community Builder",
          "block_1_row_1_value_topfan": "5-15% plus standard 3rd party credit card fees",
          "block_2_row_5_feature": "Prize Giveaway",
          "block_4_row_1_value_topfan": "Built-in Discovery",
          "competitor_column_label": "Gumroad",
          "block_3_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_document-download.png",
          "block_2_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like.png",
          "block_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_content.png",
          "block_3_row_2_value_competitor": "Audio Selling",
          "block_4_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like__1_.png",
          "block_4_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_messages-2.png",
          "heading_font_size": "medium",
          "block_4_row_5_value_competitor": "Not Available",
          "block_3_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_musicnote.png",
          "block_1_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_receipt-2.png",
          "block_1_row_1_feature": "Creator Platform Fee",
          "theme_color": "#000000",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011654314_background_flare__1_.jpg",
          "post_text_color": "#000000",
          "block_2_heading": "Monetization & Selling",
          "block_3_row_4_feature": "Downloadable Content",
          "block_3_row_5_value_competitor": "Experiences",
          "block_2_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_star.png",
          "block_1_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_key.png",
          "block_4_row_2_value_competitor": "Not available",
          "block_4_row_3_feature": "Private Chat Rooms",
          "block_2_row_4_feature": "Shopify Supported",
          "block_1_row_3_value_competitor": "Not Available",
          "block_2_row_5_value_competitor": "Not Available",
          "topfan_column_label": "TopFan",
          "block_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__2_.png",
          "block_2_row_1_value_topfan": "Supported",
          "block_3_row_1_feature": "Videos & Galleries",
          "block_3_row_4_value_topfan": "Downloadable Selling",
          "block_4_row_2_value_topfan": "Supported",
          "block_1_row_2_value_topfan": "No Fan Fee",
          "block_4_row_3_value_topfan": "Supported",
          "block_3_row_3_value_topfan": "Course Selling",
          "block_4_row_4_value_competitor": "Not Available",
          "block_4_description": "Build stronger fan relationships through interaction, discovery, and loyalty tools.",
          "block_2_row_4_value_topfan": "Supported",
          "background_text_color": "#000000",
          "block_3_description": "Sell different content formats from one creator storefront.",
          "block_1_description": "Set up, customize, and manage your creator presence with more ownership.",
          "block_2_row_5_value_topfan": "Giveaway Tools",
          "block_1_row_5_value_topfan": "Supported",
          "block_2_description": "Give creators more ways to earn through content, access, and fan purchases.",
          "updated_at": 1781872653327,
          "block_2_row_3_value_competitor": "Locked DMs",
          "block_1_row_2_feature": "Fan Platform Fee",
          "section_id": 1781872653327,
          "block_3_image_position": "right",
          "block_3_heading": "Content Commerce",
          "block_1_row_5_value_competitor": "Supported",
          "block_4_image_position": "left",
          "pk": "PAGE#1781872646064",
          "block_3_row_5_feature": "Experiences",
          "title": "COMMUNITY BUILDER",
          "block_4_row_2_feature": "Targeted Outreach",
          "block_3_row_4_value_competitor": "Downloadable Selling",
          "block_3_row_3_value_competitor": "Course Selling",
          "block_2_row_3_feature": "Paid / Locked DMs",
          "secondary_background_color": "#000000",
          "block_2_row_1_value_competitor": "Supported",
          "block_3_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_teacher.png",
          "block_2_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_sms-star.png",
          "block_1_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_money.png",
          "block_2_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_crown.png",
          "block_4_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_shield-tick.png",
          "block_2_row_4_value_competitor": "Supported",
          "block_4_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_code-circle.png",
          "block_3_row_2_feature": "Audio & Music",
          "block_3_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gallery.png",
          "block_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__3_.png",
          "block_1_row_3_feature": "Custom Website URL",
          "block_4_row_3_value_competitor": "Supported",
          "block_1_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_send-2.png",
          "block_1_row_1_value_competitor": "10% fee plus standard 3rd party credit card fees",
          "block_1_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_global.png",
          "block_2_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gift.png",
          "block_4_heading": "Fan Engagement & Growth",
          "block_4_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_coin.png",
          "block_3_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_flash.png",
          "sk": "SECTION#1781872653327"
        },
        {
          "subheading": "See how TopFans helps creators move beyond locked content with better control, wider monetization, and stronger fan-business tools.",
          "button_text_color": "#ffffff",
          "background_color": "#ffffff",
          "key_win_1_description": "TopFans gives creators custom URLs, fan data ownership, and stronger control over how they manage their fan business.",
          "key_win_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__2_.png",
          "key_win_5_title": "Engage Beyond Content Drops",
          "key_win_6_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__5_.png",
          "name": "WHERE TOPFAN WINS",
          "page_id": 1781872646064,
          "key_win_6_description": "TopFans supports creator growth through discovery, referrals, loyalty rewards, VIP access, brand opportunities, and advanced fan insights.",
          "key_win_5_description": "TopFans helps creators build stronger fan relationships through polls, private rooms, rewards, targeted messages, and paid interactions.",
          "key_win_4_title": "Own the Audience Relationship",
          "section_heading": "Where TopFan wins {over Gumroad}",
          "key_win_2_title": "Keep More From Every Sale",
          "key_win_3_description": "TopFans lets creators sell more than posts — including merchandise, courses, downloads, audio, experiences, and premium content collections.",
          "secondary_background_color": "#0f172a",
          "key_win_2_description": "TopFans offers a more creator-friendly fee structure, helping creators retain more value from memberships, paid content, and fan transactions.",
          "key_win_4_description": "With fan data ownership, segmentation, and export options, TopFans gives creators more control over their audience beyond the platform.",
          "key_win_6_title": "Built for Long-Term Growth",
          "created_at": 1781872655689,
          "heading_font_size": "medium",
          "background_text_color": "#1e293b",
          "key_win_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__3_.png",
          "theme_color": "#7c3aed",
          "key_win_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956730_featured_icon__1_.png",
          "background_image": null,
          "key_win_1_title": "More Creator Control",
          "updated_at": 1781872655689,
          "key_win_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon.png",
          "post_text_color": "#000000",
          "layout_id": "comparison-key-wins-layout",
          "section_id": 1781872655689,
          "pk": "PAGE#1781872646064",
          "key_win_3_title": "Turn Fans Into Buyers",
          "title": "WHERE TOPFAN WINS",
          "key_win_5_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__4_.png",
          "sk": "SECTION#1781872655689"
        },
        {
          "button_text_color": "#ffffff",
          "row_5_value_2": "Not Available",
          "row_4_feature": "Block Users",
          "background_color": "#000000",
          "row_5_value_1": "Web3 Support",
          "row_7_value_2": "Not Available",
          "row_6_feature": "VIP access & ticketing",
          "row_7_value_1": "Hashtag Search",
          "row_1_value_1": "Advanced Insights",
          "row_1_value_2": "Basic Analytics",
          "row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_status-up.png",
          "row_3_value_1": "Available",
          "row_8_feature": "Fan Rewards",
          "row_3_value_2": "Available",
          "row_12_value_1": "243 Languages",
          "row_10_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_tag.png",
          "row_11_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_color-swatch.png",
          "created_at": 1781872658054,
          "row_7_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_hashtag.png",
          "row_11_feature": "Designer Access",
          "row_12_value_2": "Not Available",
          "row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_fi_6699366.png",
          "row_10_value_2": "Not Available",
          "column_2_label": "Gumroad",
          "row_6_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_ticket-star.png",
          "background_text_color": "#ffffff",
          "row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-security.png",
          "row_10_value_1": "Available",
          "row_13_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_convertshape-2.png",
          "row_12_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_language-circle.png",
          "row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_user-remove.png",
          "row_9_value_1": "Collab Tools",
          "updated_at": 1781872658054,
          "layout_id": "comparison-full-table-layout",
          "section_id": 1781872658054,
          "row_8_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_award.png",
          "row_9_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_share.png",
          "pk": "PAGE#1781872646064",
          "row_2_feature": "Security Watermarking",
          "row_9_value_2": "Not Available",
          "title": "Other Advantages",
          "row_4_value_2": "User Blocking",
          "row_4_value_1": "User Blocking",
          "row_3_feature": "Stream Protection",
          "row_5_feature": "Web3 / NFT Integration",
          "name": "OTHER ADVANTAGES",
          "row_6_value_1": "VIP Tools",
          "row_6_value_2": "Not Available",
          "column_1_label": "TOPFAN",
          "page_id": 1781872646064,
          "row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-tick.png",
          "row_9_feature": "Creator Collaborations",
          "section_heading": "Other {Powerful TopFan} Advantages",
          "row_2_value_1": "Watermarking",
          "row_2_value_2": "Watermarking",
          "secondary_background_color": "#000000",
          "row_7_feature": "Hashtag Organization",
          "row_13_feature": "Referral Program",
          "row_12_feature": "Auto Translation",
          "row_13_value_2": "Not Available",
          "row_13_value_1": "Higher Rewards",
          "heading_font_size": "medium",
          "row_10_feature": "Brand Ads",
          "row_11_value_1": "Coming Soon",
          "theme_color": "#7c3aed",
          "row_11_value_2": "Not Available",
          "background_image": null,
          "post_text_color": "#ffffff",
          "row_8_value_2": "Not Available",
          "row_8_value_1": "Rewards Supported",
          "row_1_feature": "Rich analytics",
          "section_subheading": "Additional tools that support safety, analytics, automation, and advanced creator workflows.",
          "sk": "SECTION#1781872658054"
        },
        {
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "name": "SUMMARY",
          "summary_heading": "Summary",
          "page_id": 1781872646064,
          "card_b_heading": "Who is Gumroad best suited for?",
          "secondary_background_color": "#f7f7f7",
          "created_at": 1781872660408,
          "summary_text": "Gumroad offers more monetization flexibility than many creator platforms, with a 10% fee, anti-screenshot DRM, and digital product sales built in. But it still operates as a closed platform — your audience lives on Passes' infrastructure, under their domain, and you don't own your fan data. \n\nTopFan is built around the opposite model: your own branded site, your own URL, full fan data ownership, and a broader toolkit that includes courses, experiences, loyalty tools, and community-led growth — without giving up control to a third-party platform.",
          "heading_font_size": "medium",
          "card_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1781850750727_gumroad.png",
          "card_a_body": "TopFan is built for creators who want to grow beyond exclusive content. Helps creators sell memberships, videos, courses, downloads, merchandise, experiences, and fan access from one platform. TopFan is best suited for creators and creator teams who want stronger fan ownership, deeper engagement, multiple revenue streams, and community-led growth.",
          "background_text_color": "#1b1b1b",
          "card_a_heading": "Who is TopFan best suited for?",
          "theme_color": "#7c3aed",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011640635_background_flare__1_.jpg",
          "updated_at": 1781872660408,
          "post_text_color": "#000000",
          "layout_id": "comparison-audience-summary-layout",
          "section_id": 1781872660408,
          "card_b_body": "Gumroad is best suited for established creators who want a monetization-focused platform with subscriptions, paid DMs, and digital product sales. It works well for influencers with an existing audience who want multiple revenue streams and strong content protection. However, creators who need a custom-branded destination, full fan data ownership, course-building tools, loyalty gamification, or community-led growth features will find Passes falls short of a complete creator business platform.",
          "pk": "PAGE#1781872646064",
          "card_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780922932705_group.png",
          "title": "SUMMARY",
          "sk": "SECTION#1781872660408"
        },
        {
          "button_text_color": "#ffffff",
          "testimonial_6_background_image": null,
          "background_color": "#d0e9ee",
          "testimonial_4_creator_type": "Professionals",
          "testimonial_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
          "testimonial_6_name": "The Predictors",
          "testimonial_2_user_name": "julia-kugel",
          "testimonial_6_creator_type": "Organizations",
          "testimonial_4_stars": "5",
          "testimonial_5_name": "Tulsa Bite",
          "testimonial_2_content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
          "testimonial_7_stars": "5",
          "testimonial_5_user_name": "tulsa_bite",
          "testimonial_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
          "testimonial_7_background_image": null,
          "testimonial_title": "Testimonials",
          "created_at": 1781872662930,
          "testimonial_4_background_image": null,
          "testimonial_5_stars": "5",
          "testimonial_1_user_name": "johnward",
          "background_text_color": "#000000",
          "testimonial_5_content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space.",
          "updated_at": 1781872662930,
          "testimonial_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
          "layout_id": "testimonial-layout",
          "section_id": 1781872662930,
          "testimonial_7_redirection_link": "https://www.markschlereth.fans/",
          "testimonial_1_stars": "5",
          "testimonial_4_user_name": "davidgold",
          "testimonial_2_redirection_link": "https://www.juliajulia.fans/",
          "pk": "PAGE#1781872646064",
          "testimonial_7_content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform.",
          "testimonial_5_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
          "title": "TESTIMONIALS",
          "testimonial_3_name": "Katrina Darling Friedman",
          "testimonial_7_user_name": "markschlereth",
          "testimonial_6_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
          "testimonial_5_creator_type": "Creator and Influencer",
          "testimonial_1_background_image": null,
          "testimonial_3_redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
          "name": "TESTIMONIALS",
          "testimonial_7_creator_type": "Athletes",
          "testimonial_3_user_name": "katrinadarlingfriedman",
          "testimonial_3_content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
          "page_id": 1781872646064,
          "testimonial_3_background_image": null,
          "section_heading": "More than {1,000} Creators Have Trusted Us Since We Started.",
          "testimonial_4_redirection_link": "https://www.goldweatherkingdom.com/",
          "testimonial_2_background_image": null,
          "testimonial_5_redirection_link": "https://www.topfan.com/tulsa_bite",
          "testimonial_1_content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
          "secondary_background_color": "#000000",
          "testimonial_2_stars": "5",
          "testimonial_2_name": "Julia Julia",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "johnward",
              "name": "John Ward",
              "redirection_link": "https://www.topfan.com/johnward",
              "stars": "5",
              "content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
              "creator_type": "Musicians",
              "user_name": "julia-kugel",
              "name": "Julia Julia",
              "redirection_link": "https://www.juliajulia.fans/",
              "stars": "5",
              "content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!"
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "katrinadarlingfriedman",
              "name": "Katrina Darling Friedman",
              "redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
              "stars": "5",
              "content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
              "creator_type": "Professionals",
              "user_name": "davidgold",
              "name": "David Gold",
              "redirection_link": "https://www.goldweatherkingdom.com/",
              "stars": "5",
              "content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
              "creator_type": "Creator and Influencer",
              "user_name": "tulsa_bite",
              "name": "Tulsa Bite",
              "redirection_link": "https://www.topfan.com/tulsa_bite",
              "stars": "5",
              "content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
              "creator_type": "Organizations",
              "user_name": "the-predictors",
              "name": "The Predictors",
              "redirection_link": "https://www.thepredictors.fans/",
              "stars": "5",
              "content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
              "creator_type": "Athletes",
              "user_name": "markschlereth",
              "name": "Mark Schlereth",
              "redirection_link": "https://www.markschlereth.fans/",
              "stars": "5",
              "content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform."
            }
          ],
          "testimonial_6_redirection_link": "https://www.thepredictors.fans/",
          "testimonial_6_user_name": "the-predictors",
          "testimonial_6_content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers.",
          "heading_font_size": "medium",
          "testimonial_1_redirection_link": "https://www.topfan.com/johnward",
          "testimonial_3_stars": "5",
          "testimonial_7_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
          "testimonial_1_name": "John Ward",
          "testimonial_4_content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.",
          "testimonial_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
          "theme_color": "#141515",
          "background_image": null,
          "testimonial_5_background_image": null,
          "post_text_color": "#ffffff",
          "testimonial_6_stars": "5",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_4_name": "David Gold",
          "testimonial_1_creator_type": "Food, Fitness and Wellness",
          "testimonial_7_name": "Mark Schlereth",
          "testimonial_3_creator_type": "Food, Fitness and Wellness",
          "sk": "SECTION#1781872662930"
        }
      ]
    }
  },
  "topfan-vs-kajabi": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "sk": "PAGE#1781873420435",
      "title": "Kajabi",
      "created_at": 1781873420435,
      "post_text_color": "#ffffff",
      "url": "topfan-vs-kajabi",
      "status": "PUBLISHED",
      "meta_title": "TopFan vs Kajabi: Which is the better platform?",
      "type": "MARKETING_COMPARISON",
      "background_color": "#000000",
      "sequence_number": 2,
      "competitor_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780989813216_frame_2147226358.png",
      "meta_description": "Compare TopFan vs Kajabi on pricing, features, and fan monetization. See why creators are leaving $179+/month Kajabi fees for a platform built around community and revenue ownership",
      "text_color": "#000000",
      "button_text_color": "#ffffff",
      "pk": "MARKETINGPAGE",
      "gsi1pk": "topfan-vs-kajabi",
      "page_id": 1781873420435,
      "secondary_background_color": "#000000",
      "updated_at": 1781873420435,
      "seoKeywords": "fan vs kajabi, kajabi alternative, free course platform for creators, creator monetization platform, kajabi pricing comparison, all-in-one platform for creators",
      "gsi1sk": "PAGE#1781873420435",
      "background_text_color": "#ffffff",
      "sections": [
        {
          "subheading": "TopFan is a creator-first platform helping you grow, engage, and earn through courses, subscriptions, and live experiences — free to use, with no $179+/month software fee required.",
          "button_text_color": "#ffffff",
          "created_at": 1781873422843,
          "competitor_name": "Kajabi",
          "background_color": "#ffffff",
          "heading_font_size": "large",
          "background_text_color": "#000000",
          "theme_color": "#7c3aed",
          "name": "HERO PAGE",
          "platform_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780920210571_group.png",
          "background_image": null,
          "updated_at": 1781873422843,
          "page_id": 1781873420435,
          "post_text_color": "#000000",
          "layout_id": "comparison-hero-layout",
          "section_id": 1781873422843,
          "section_heading": "{TopFan vs Kajabi: Which is the better platform?}",
          "secondary_background_color": "#000000",
          "platform_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990791655_frame_2147226358.png",
          "pk": "PAGE#1781873420435",
          "title": "Hero Page",
          "sk": "SECTION#1781873422843"
        },
        {
          "subheading": "TopFans gives creators the tools to monetize, engage, grow, & manage their fan business.",
          "value_card_1_description": "Sell memberships, exclusive content, tips, paid DMs, merchandise, courses, and experiences from one platform.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "value_card_3_description": "Grow beyond social media with discovery tools, referrals, loyal fan rewards, and brand partnership opportunities.",
          "value_card_4_description": "Own your fan data, track content performance, manage access, and protect your content with built-in safety tools.",
          "name": "WHY CHOOSE TOPFAN",
          "page_id": 1781873420435,
          "value_card_2_title": "Deeper Fan Engagement",
          "section_heading": "{Why Choose TopFan?}",
          "value_card_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_message-chat-circle.png",
          "secondary_background_color": "#1f1f1e",
          "value_card_2_description": "Build stronger relationships through direct messages, polls, private communities, rewards, and personalized fan interactions.",
          "created_at": 1781873425224,
          "value_card_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-04.png",
          "heading_font_size": "medium",
          "value_card_4_title": "Full Control & Insights",
          "background_text_color": "#ffffff",
          "theme_color": "#5e00ff",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1780920467614_cb2078a3a11ac679ddb58d9cc8cf4c8bef941e9d__1_.png",
          "updated_at": 1781873425224,
          "post_text_color": "#ffffff",
          "layout_id": "comparison-value-grid-layout",
          "section_id": 1781873425224,
          "value_card_3_title": "Creator-Led Growth",
          "value_card_1_title": "More Ways to Earn",
          "value_card_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-03.png",
          "pk": "PAGE#1781873420435",
          "title": "WHY CHOOSE TOPFAN",
          "value_card_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_line-chart-up-03.png",
          "sk": "SECTION#1781873425224"
        },
        {
          "block_2_image_position": "left",
          "button_text_color": "#ffffff",
          "block_1_row_4_value_competitor": "Limited Control",
          "background_color": "#ffffff",
          "block_4_row_1_feature": "Discovery Algorithm",
          "block_2_row_2_feature": "Tips on content & DMs",
          "block_4_row_1_value_competitor": "Limited",
          "block_4_row_5_feature": "Loyalty Gamification",
          "block_3_row_1_value_topfan": "Media Selling",
          "block_3_row_2_value_topfan": "Audio Selling",
          "block_4_row_5_value_topfan": "Loyalty Tools",
          "block_4_row_4_value_topfan": "Supported",
          "block_2_row_2_value_topfan": "Tips Supported",
          "created_at": 1781873427602,
          "block_2_row_3_value_topfan": "Locked DMs",
          "block_1_row_3_value_topfan": "Custom URL",
          "block_3_row_3_feature": "Online Courses",
          "block_1_row_4_value_topfan": "Full Ownership",
          "block_1_row_2_value_competitor": "No Fan Fee",
          "block_1_heading": "Creator Setup & Control",
          "block_3_row_5_value_topfan": "Experience Selling",
          "layout_id": "comparison-feature-section-layout",
          "block_3_row_1_value_competitor": "Media Selling",
          "block_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__1_.png",
          "block_1_row_4_feature": "Fan Data Ownership",
          "subheading": "A full-stack online community platform designed for flexibility and scalability, empowering organizations to build, manage, and engage communities with ease.",
          "block_2_row_2_value_competitor": "Limited",
          "block_4_row_4_feature": "Polls",
          "block_1_row_5_feature": "Publishing Scheduler",
          "block_2_row_1_feature": "Membership Tiers",
          "name": "COMMUNITY BUILDER",
          "page_id": 1781873420435,
          "block_1_image_position": "right",
          "section_heading": "{TopFan} is more than a Community Builder",
          "block_1_row_1_value_topfan": "5-15% plus standard 3rd party credit card fees",
          "block_2_row_5_feature": "Prize Giveaway",
          "block_4_row_1_value_topfan": "Built-in Discovery",
          "competitor_column_label": "Kajabi",
          "block_3_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_document-download.png",
          "block_2_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like.png",
          "block_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_content.png",
          "block_3_row_2_value_competitor": "Audio Selling",
          "block_4_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like__1_.png",
          "block_4_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_messages-2.png",
          "heading_font_size": "medium",
          "block_4_row_5_value_competitor": "Loyalty Tools",
          "block_3_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_musicnote.png",
          "block_1_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_receipt-2.png",
          "block_1_row_1_feature": "Creator Platform Fee",
          "theme_color": "#000000",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011757819_background_flare__1_.jpg",
          "post_text_color": "#000000",
          "block_2_heading": "Monetization & Selling",
          "block_3_row_4_feature": "Downloadable Content",
          "block_3_row_5_value_competitor": "Limted",
          "block_2_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_star.png",
          "block_1_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_key.png",
          "block_4_row_2_value_competitor": "Supported",
          "block_4_row_3_feature": "Private Chat Rooms",
          "block_2_row_4_feature": "Shopify Supported",
          "block_1_row_3_value_competitor": "Custom URL",
          "block_2_row_5_value_competitor": "Not Available",
          "topfan_column_label": "TopFan",
          "block_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__2_.png",
          "block_2_row_1_value_topfan": "Supported",
          "block_3_row_1_feature": "Videos & Galleries",
          "block_3_row_4_value_topfan": "Downloadable Selling",
          "block_4_row_2_value_topfan": "Supported",
          "block_1_row_2_value_topfan": "No Fan Fee",
          "block_4_row_3_value_topfan": "Supported",
          "block_3_row_3_value_topfan": "Course Selling",
          "block_4_row_4_value_competitor": "Supported",
          "block_4_description": "Build stronger fan relationships through interaction, discovery, and loyalty tools.",
          "block_2_row_4_value_topfan": "Supported",
          "background_text_color": "#000000",
          "block_3_description": "Sell different content formats from one creator storefront.",
          "block_1_description": "Set up, customize, and manage your creator presence with more ownership.",
          "block_2_row_5_value_topfan": "Giveaway Tools",
          "block_1_row_5_value_topfan": "Supported",
          "block_2_description": "Give creators more ways to earn through content, access, and fan purchases.",
          "updated_at": 1781873427602,
          "block_2_row_3_value_competitor": "Locked DMs",
          "block_1_row_2_feature": "Fan Platform Fee",
          "section_id": 1781873427602,
          "block_3_image_position": "right",
          "block_3_heading": "Content Commerce",
          "block_1_row_5_value_competitor": "Supported",
          "block_4_image_position": "left",
          "pk": "PAGE#1781873420435",
          "block_3_row_5_feature": "Experiences",
          "title": "COMMUNITY BUILDER",
          "block_4_row_2_feature": "Targeted Outreach",
          "block_3_row_4_value_competitor": "Downloadable Selling",
          "block_3_row_3_value_competitor": "Course Selling",
          "block_2_row_3_feature": "Paid / Locked DMs",
          "secondary_background_color": "#000000",
          "block_2_row_1_value_competitor": "Supported",
          "block_3_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_teacher.png",
          "block_2_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_sms-star.png",
          "block_1_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_money.png",
          "block_2_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_crown.png",
          "block_4_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_shield-tick.png",
          "block_2_row_4_value_competitor": "Not Supported",
          "block_4_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_code-circle.png",
          "block_3_row_2_feature": "Audio & Music",
          "block_3_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gallery.png",
          "block_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__3_.png",
          "block_1_row_3_feature": "Custom Website URL",
          "block_4_row_3_value_competitor": "Supported",
          "block_1_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_send-2.png",
          "block_1_row_1_value_competitor": "$149-$499+/month plus standard 3rd party credit card fees",
          "block_1_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_global.png",
          "block_2_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gift.png",
          "block_4_heading": "Fan Engagement & Growth",
          "block_4_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_coin.png",
          "block_3_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_flash.png",
          "sk": "SECTION#1781873427602"
        },
        {
          "subheading": "See how TopFans helps creators move beyond locked content with better control, wider monetization, and stronger fan-business tools.",
          "button_text_color": "#ffffff",
          "background_color": "#ffffff",
          "key_win_1_description": "TopFan is completely free for creators and gives you a fully white-labeled website and app from day one, while Kajabi charges $149–$499+/month before you sell a single thing and locks branding removal behind its $199+/month Growth plan.",
          "key_win_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__2_.png",
          "key_win_5_title": "Engage Beyond Content Drops",
          "key_win_6_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__5_.png",
          "name": "WHERE TOPFAN WINS",
          "page_id": 1781873420435,
          "key_win_6_description": "TopFan includes referral tools, real ticketing, and brand collaboration features for every creator, free, while Kajabi locks its affiliate program behind the $199+/month Growth plan with no native way to collaborate on a joint offer.",
          "key_win_5_description": "TopFan pairs built-in gamification and loyalty rewards with a true discovery algorithm built to grow your audience, while Kajabi's Marketplace is just a curated directory with no rewards marketplace behind its points and badges.",
          "key_win_4_title": "Own the Audience Relationship",
          "section_heading": "Where TopFan wins {over Kajabi}",
          "key_win_2_title": "Keep More From Every Sale",
          "key_win_3_description": "TopFan gives you subscriptions, merch, tickets, and ads in one connected platform, while Kajabi has no native Shopify integration or built-in giveaway tool — both require third-party workarounds.",
          "secondary_background_color": "#0f172a",
          "key_win_2_description": "Keep up to 95% of every merch and ticket sale and 85% on subscriptions with TopFan — no software fee, ever — while Kajabi charges a mandatory monthly subscription plus processing and surcharges whether you make a sale or not.",
          "key_win_4_description": "Your fans, your data, your relationship — built in from the start with TopFan, while Kajabi's contact exports are capped to your plan size and arrive via an email link that expires in days.",
          "key_win_6_title": "Built for Long-Term Growth",
          "created_at": 1781873429959,
          "heading_font_size": "medium",
          "background_text_color": "#1e293b",
          "key_win_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__3_.png",
          "theme_color": "#7c3aed",
          "key_win_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956730_featured_icon__1_.png",
          "background_image": null,
          "key_win_1_title": "More Creator Control",
          "updated_at": 1781873429959,
          "key_win_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon.png",
          "post_text_color": "#000000",
          "layout_id": "comparison-key-wins-layout",
          "section_id": 1781873429959,
          "pk": "PAGE#1781873420435",
          "key_win_3_title": "Turn Fans Into Buyers",
          "title": "WHERE TOPFAN WINS",
          "key_win_5_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__4_.png",
          "sk": "SECTION#1781873429959"
        },
        {
          "button_text_color": "#ffffff",
          "row_5_value_2": "Not Available",
          "row_4_feature": "Block Users",
          "background_color": "#000000",
          "row_5_value_1": "Web3 Support",
          "row_7_value_2": "Not Available",
          "row_6_feature": "VIP access & ticketing",
          "row_7_value_1": "Hashtag Search",
          "row_1_value_1": "Advanced Insights",
          "row_1_value_2": "Course Analytics Only",
          "row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_status-up.png",
          "row_3_value_1": "Available",
          "row_8_feature": "Fan Rewards",
          "row_3_value_2": "Not Available",
          "row_12_value_1": "243 Languages",
          "row_10_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_tag.png",
          "row_11_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_color-swatch.png",
          "created_at": 1781873432400,
          "row_11_feature": "Designer Access",
          "row_7_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_hashtag.png",
          "row_12_value_2": "16 Languages",
          "row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_fi_6699366.png",
          "row_10_value_2": "Not Available",
          "column_2_label": "Kajabi",
          "row_6_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_ticket-star.png",
          "background_text_color": "#ffffff",
          "row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-security.png",
          "row_10_value_1": "Available",
          "row_13_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_convertshape-2.png",
          "row_12_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_language-circle.png",
          "row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_user-remove.png",
          "row_9_value_1": "Collab Tools",
          "updated_at": 1781873432400,
          "layout_id": "comparison-full-table-layout",
          "section_id": 1781873432400,
          "row_8_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_award.png",
          "row_9_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_share.png",
          "pk": "PAGE#1781873420435",
          "row_2_feature": "Security Watermarking",
          "row_9_value_2": "Not Available",
          "title": "Other Advantages",
          "row_4_value_2": "User Blocking",
          "row_4_value_1": "User Blocking",
          "row_3_feature": "Stream Protection",
          "row_5_feature": "Web3 / NFT Integration",
          "name": "OTHER ADVANTAGES",
          "row_6_value_1": "VIP Tools",
          "row_6_value_2": "Event Tickets Only",
          "column_1_label": "TOPFAN",
          "page_id": 1781873420435,
          "row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-tick.png",
          "row_9_feature": "Creator Collaborations",
          "section_heading": "Other {Powerful TopFan} Advantages",
          "row_2_value_1": "Watermarking",
          "row_2_value_2": "Not Available",
          "secondary_background_color": "#000000",
          "row_7_feature": "Hashtag Organization",
          "row_13_feature": "Referral Program",
          "row_12_feature": "Auto Translation",
          "row_13_value_2": "Growth Plan Only",
          "row_13_value_1": "Higher Rewards",
          "heading_font_size": "medium",
          "row_10_feature": "Brand Ads",
          "row_11_value_1": "Coming Soon",
          "theme_color": "#7c3aed",
          "row_11_value_2": "Coming Soon",
          "background_image": null,
          "post_text_color": "#ffffff",
          "row_8_value_2": "Points, No Marketplace",
          "row_8_value_1": "Rewards Supported",
          "row_1_feature": "Rich analytics",
          "section_subheading": "Additional tools that support safety, analytics, automation, and advanced creator workflows.",
          "sk": "SECTION#1781873432400"
        },
        {
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "name": "SUMMARY",
          "summary_heading": "Summary",
          "page_id": 1781873420435,
          "card_b_heading": "Who is Kajabi best suited for?",
          "secondary_background_color": "#f7f7f7",
          "created_at": 1781873434749,
          "summary_text": "While Kajabi focuses mainly on structured courses, drip content, and email funnels, TopFan is designed as a broader creator growth platform. TopFan gives creators more ways to earn, engage, and scale through memberships, content commerce, merchandise, courses, experiences, fan ownership, loyalty tools, and community-led growth — without Kajabi's recurring software fee.",
          "heading_font_size": "medium",
          "card_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990808360_frame_2147226358.png",
          "card_a_body": "TopFan is built for creators who want to grow beyond exclusive content. Helps creators sell memberships, videos, courses, downloads, merchandise, experiences, and fan access from one platform. TopFan is best suited for creators and creator teams who want stronger fan ownership, deeper engagement, multiple revenue streams, and community-led growth.",
          "background_text_color": "#1b1b1b",
          "card_a_heading": "Who is TopFan best suited for?",
          "theme_color": "#7c3aed",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011746663_background_flare__1_.jpg",
          "updated_at": 1781873434749,
          "post_text_color": "#000000",
          "layout_id": "comparison-audience-summary-layout",
          "section_id": 1781873434749,
          "card_b_body": "Kajabi is built for course creators and coaches running a structured curriculum business — people who want drip-fed lessons, email funnels, and their own affiliates selling for them. However, creators wanting a true fan community, social-style engagement, or to keep what they earn without a recurring $150–500+/month bill may need a more complete platform experience",
          "pk": "PAGE#1781873420435",
          "card_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780922932705_group.png",
          "title": "SUMMARY",
          "sk": "SECTION#1781873434749"
        },
        {
          "button_text_color": "#ffffff",
          "testimonial_6_background_image": null,
          "background_color": "#d0e9ee",
          "testimonial_4_creator_type": "Professionals",
          "testimonial_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
          "testimonial_6_name": "The Predictors",
          "testimonial_2_user_name": "julia-kugel",
          "testimonial_6_creator_type": "Organizations",
          "testimonial_4_stars": "5",
          "testimonial_5_name": "Tulsa Bite",
          "testimonial_2_content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
          "testimonial_7_stars": "5",
          "testimonial_5_user_name": "tulsa_bite",
          "testimonial_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
          "testimonial_7_background_image": null,
          "testimonial_title": "Testimonials",
          "created_at": 1781873437206,
          "testimonial_4_background_image": null,
          "testimonial_5_stars": "5",
          "testimonial_1_user_name": "johnward",
          "background_text_color": "#000000",
          "testimonial_5_content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space.",
          "updated_at": 1781873437206,
          "testimonial_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
          "layout_id": "testimonial-layout",
          "section_id": 1781873437206,
          "testimonial_7_redirection_link": "https://www.markschlereth.fans/",
          "testimonial_1_stars": "5",
          "testimonial_4_user_name": "davidgold",
          "testimonial_2_redirection_link": "https://www.juliajulia.fans/",
          "pk": "PAGE#1781873420435",
          "testimonial_7_content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform.",
          "testimonial_5_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
          "title": "TESTIMONIALS",
          "testimonial_3_name": "Katrina Darling Friedman",
          "testimonial_7_user_name": "markschlereth",
          "testimonial_6_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
          "testimonial_5_creator_type": "Creator and Influencer",
          "testimonial_1_background_image": null,
          "testimonial_3_redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
          "name": "TESTIMONIALS",
          "testimonial_7_creator_type": "Athletes",
          "testimonial_3_user_name": "katrinadarlingfriedman",
          "testimonial_3_content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
          "page_id": 1781873420435,
          "testimonial_3_background_image": null,
          "section_heading": "More than {1,000} Creators Have Trusted Us Since We Started.",
          "testimonial_4_redirection_link": "https://www.goldweatherkingdom.com/",
          "testimonial_2_background_image": null,
          "testimonial_5_redirection_link": "https://www.topfan.com/tulsa_bite",
          "testimonial_1_content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
          "secondary_background_color": "#000000",
          "testimonial_2_stars": "5",
          "testimonial_2_name": "Julia Julia",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "johnward",
              "name": "John Ward",
              "redirection_link": "https://www.topfan.com/johnward",
              "stars": "5",
              "content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
              "creator_type": "Musicians",
              "user_name": "julia-kugel",
              "name": "Julia Julia",
              "redirection_link": "https://www.juliajulia.fans/",
              "stars": "5",
              "content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!"
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "katrinadarlingfriedman",
              "name": "Katrina Darling Friedman",
              "redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
              "stars": "5",
              "content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
              "creator_type": "Professionals",
              "user_name": "davidgold",
              "name": "David Gold",
              "redirection_link": "https://www.goldweatherkingdom.com/",
              "stars": "5",
              "content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
              "creator_type": "Creator and Influencer",
              "user_name": "tulsa_bite",
              "name": "Tulsa Bite",
              "redirection_link": "https://www.topfan.com/tulsa_bite",
              "stars": "5",
              "content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
              "creator_type": "Organizations",
              "user_name": "the-predictors",
              "name": "The Predictors",
              "redirection_link": "https://www.thepredictors.fans/",
              "stars": "5",
              "content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
              "creator_type": "Athletes",
              "user_name": "markschlereth",
              "name": "Mark Schlereth",
              "redirection_link": "https://www.markschlereth.fans/",
              "stars": "5",
              "content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform."
            }
          ],
          "testimonial_6_redirection_link": "https://www.thepredictors.fans/",
          "testimonial_6_user_name": "the-predictors",
          "testimonial_6_content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers.",
          "heading_font_size": "medium",
          "testimonial_1_redirection_link": "https://www.topfan.com/johnward",
          "testimonial_3_stars": "5",
          "testimonial_7_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
          "testimonial_1_name": "John Ward",
          "testimonial_4_content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.",
          "testimonial_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
          "theme_color": "#141515",
          "testimonial_5_background_image": null,
          "post_text_color": "#ffffff",
          "testimonial_6_stars": "5",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_4_name": "David Gold",
          "testimonial_1_creator_type": "Food, Fitness and Wellness",
          "testimonial_7_name": "Mark Schlereth",
          "testimonial_3_creator_type": "Food, Fitness and Wellness",
          "sk": "SECTION#1781873437206"
        }
      ]
    }
  },
  "topfan-vs-mighty": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "created_at": 1781873303586,
      "background_text_color": "#ffffff",
      "type": "MARKETING_COMPARISON",
      "gsi1sk": "PAGE#1781873303586",
      "secondary_background_color": "#000000",
      "text_color": "#000000",
      "gsi1pk": "topfan-vs-mighty",
      "button_text_color": "#ffffff",
      "status": "PUBLISHED",
      "sk": "PAGE#1781873303586",
      "pk": "MARKETINGPAGE",
      "background_color": "#000000",
      "page_id": 1781873303586,
      "meta_description": "See how TopFan stacks up against Mighty Networks on pricing and branded apps — why your own app shouldn't be locked behind a $179/month tier.",
      "sequence_number": 5,
      "updated_at": 1781873303586,
      "seoKeywords": "topfan vs mighty networks, mighty networks alternative, free community platform for creators, creator monetization platform, mighty networks pricing comparison, branded app for creators",
      "meta_title": "TopFan vs Mighty: Which is the better platform?",
      "competitor_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990520713_frame_2147226360__1_.png",
      "url": "topfan-vs-mighty",
      "title": "Mighty",
      "post_text_color": "#ffffff",
      "sections": [
        {
          "subheading": "TopFan is a creator-first platform helping you grow, engage, and earn through community, courses, and live experiences — with your own branded app included, not an upgrade like Mighty charges for.",
          "button_text_color": "#ffffff",
          "created_at": 1781873305984,
          "competitor_name": "Fanfix",
          "background_color": "#ffffff",
          "heading_font_size": "large",
          "background_text_color": "#000000",
          "theme_color": "#7c3aed",
          "name": "HERO PAGE",
          "platform_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780920210571_group.png",
          "background_image": null,
          "updated_at": 1781873305984,
          "page_id": 1781873303586,
          "post_text_color": "#000000",
          "layout_id": "comparison-hero-layout",
          "section_id": 1781873305984,
          "section_heading": "{TopFan vs Mighty: Which is the better platform?}",
          "secondary_background_color": "#000000",
          "platform_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990875123_frame_2147226360__1_.png",
          "pk": "PAGE#1781873303586",
          "title": "Hero Page",
          "sk": "SECTION#1781873305984"
        },
        {
          "subheading": "TopFans gives creators the tools to monetize, engage, grow, & manage their fan business.",
          "value_card_1_description": "Sell memberships, exclusive content, tips, paid DMs, merchandise, courses, and experiences from one platform.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "value_card_3_description": "Grow beyond social media with discovery tools, referrals, loyal fan rewards, and brand partnership opportunities.",
          "value_card_4_description": "Own your fan data, track content performance, manage access, and protect your content with built-in safety tools.",
          "name": "WHY CHOOSE TOPFAN",
          "page_id": 1781873303586,
          "value_card_2_title": "Deeper Fan Engagement",
          "section_heading": "{Why Choose TopFan?}",
          "value_card_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_message-chat-circle.png",
          "secondary_background_color": "#1f1f1e",
          "value_card_2_description": "Build stronger relationships through direct messages, polls, private communities, rewards, and personalized fan interactions.",
          "created_at": 1781873308344,
          "value_card_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-04.png",
          "heading_font_size": "medium",
          "value_card_4_title": "Full Control & Insights",
          "background_text_color": "#ffffff",
          "theme_color": "#5e00ff",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1780920467614_cb2078a3a11ac679ddb58d9cc8cf4c8bef941e9d__1_.png",
          "updated_at": 1781873308344,
          "post_text_color": "#ffffff",
          "layout_id": "comparison-value-grid-layout",
          "section_id": 1781873308344,
          "value_card_3_title": "Creator-Led Growth",
          "value_card_1_title": "More Ways to Earn",
          "value_card_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-03.png",
          "pk": "PAGE#1781873303586",
          "title": "WHY CHOOSE TOPFAN",
          "value_card_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_line-chart-up-03.png",
          "sk": "SECTION#1781873308344"
        },
        {
          "block_2_image_position": "left",
          "button_text_color": "#ffffff",
          "block_1_row_4_value_competitor": "Full Ownership",
          "background_color": "#ffffff",
          "block_4_row_1_feature": "Discovery Algorithm",
          "block_2_row_2_feature": "Tips on content & DMs",
          "block_4_row_1_value_competitor": "Not Available",
          "block_4_row_5_feature": "Loyalty Gamification",
          "block_3_row_1_value_topfan": "Media Selling",
          "block_3_row_2_value_topfan": "Audio Selling",
          "block_4_row_5_value_topfan": "Loyalty Tools",
          "block_4_row_4_value_topfan": "Supported",
          "block_2_row_2_value_topfan": "Tips Supported",
          "created_at": 1781873310755,
          "block_2_row_3_value_topfan": "Locked DMs",
          "block_1_row_3_value_topfan": "Custom URL",
          "block_3_row_3_feature": "Online Courses",
          "block_1_row_4_value_topfan": "Full Ownership",
          "block_1_row_2_value_competitor": "No Fan Fee",
          "block_1_heading": "Creator Setup & Control",
          "block_3_row_5_value_topfan": "Experience Selling",
          "layout_id": "comparison-feature-section-layout",
          "block_3_row_1_value_competitor": "Media Selling",
          "block_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__1_.png",
          "block_1_row_4_feature": "Fan Data Ownership",
          "subheading": "A full-stack online community platform designed for flexibility and scalability, empowering organizations to build, manage, and engage communities with ease.",
          "block_2_row_2_value_competitor": "Not Supported",
          "block_4_row_4_feature": "Polls",
          "block_1_row_5_feature": "Publishing Scheduler",
          "block_2_row_1_feature": "Membership Tiers",
          "name": "COMMUNITY BUILDER",
          "page_id": 1781873303586,
          "block_1_image_position": "right",
          "section_heading": "{TopFan} is more than a Community Builder",
          "block_1_row_1_value_topfan": "5-15% plus standard 3rd party credit card fees",
          "block_2_row_5_feature": "Prize Giveaway",
          "block_4_row_1_value_topfan": "Built-in Discovery",
          "competitor_column_label": "Mighty",
          "block_3_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_document-download.png",
          "block_2_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like.png",
          "block_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_content.png",
          "block_3_row_2_value_competitor": "Audio Selling",
          "block_4_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like__1_.png",
          "block_4_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_messages-2.png",
          "heading_font_size": "medium",
          "block_4_row_5_value_competitor": "Loyalty Tools",
          "block_3_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_musicnote.png",
          "block_1_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_receipt-2.png",
          "block_1_row_1_feature": "Creator Platform Fee",
          "theme_color": "#000000",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011822294_background_flare__1_.jpg",
          "post_text_color": "#000000",
          "block_2_heading": "Monetization & Selling",
          "block_3_row_4_feature": "Downloadable Content",
          "block_3_row_5_value_competitor": "Limited (Higher tiers only)",
          "block_2_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_star.png",
          "block_1_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_key.png",
          "block_4_row_2_value_competitor": "Limited",
          "block_4_row_3_feature": "Private Chat Rooms",
          "block_2_row_4_feature": "Shopify Supported",
          "block_1_row_3_value_competitor": "Custom URL (Paid plan only)",
          "block_2_row_5_value_competitor": "Not Available",
          "topfan_column_label": "TopFan",
          "block_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__2_.png",
          "block_2_row_1_value_topfan": "Supported",
          "block_3_row_1_feature": "Videos & Galleries",
          "block_3_row_4_value_topfan": "Downloadable Selling",
          "block_4_row_2_value_topfan": "Supported",
          "block_1_row_2_value_topfan": "No Fan Fee",
          "block_4_row_3_value_topfan": "Supported",
          "block_3_row_3_value_topfan": "Course Selling",
          "block_4_row_4_value_competitor": "Supported",
          "block_4_description": "Build stronger fan relationships through interaction, discovery, and loyalty tools.",
          "block_2_row_4_value_topfan": "Supported",
          "background_text_color": "#000000",
          "block_3_description": "Sell different content formats from one creator storefront.",
          "block_1_description": "Set up, customize, and manage your creator presence with more ownership.",
          "block_2_row_5_value_topfan": "Giveaway Tools",
          "block_1_row_5_value_topfan": "Supported",
          "block_2_description": "Give creators more ways to earn through content, access, and fan purchases.",
          "updated_at": 1781873310755,
          "block_2_row_3_value_competitor": "Not Supported",
          "block_1_row_2_feature": "Fan Platform Fee",
          "section_id": 1781873310755,
          "block_3_image_position": "right",
          "block_3_heading": "Content Commerce",
          "block_1_row_5_value_competitor": "Limited",
          "block_4_image_position": "left",
          "pk": "PAGE#1781873303586",
          "block_3_row_5_feature": "Experiences",
          "title": "COMMUNITY BUILDER",
          "block_4_row_2_feature": "Targeted Outreach",
          "block_3_row_4_value_competitor": "Not Available",
          "block_3_row_3_value_competitor": "Not Available",
          "block_2_row_3_feature": "Paid / Locked DMs",
          "secondary_background_color": "#000000",
          "block_2_row_1_value_competitor": "Supported",
          "block_3_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_teacher.png",
          "block_2_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_sms-star.png",
          "block_1_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_money.png",
          "block_2_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_crown.png",
          "block_4_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_shield-tick.png",
          "block_2_row_4_value_competitor": "Not Supported",
          "block_4_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_code-circle.png",
          "block_3_row_2_feature": "Audio & Music",
          "block_3_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gallery.png",
          "block_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__3_.png",
          "block_1_row_3_feature": "Custom Website URL",
          "block_4_row_3_value_competitor": "Supported",
          "block_1_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_send-2.png",
          "block_1_row_1_value_competitor": "$79+/mo plus standard 3rd party credit card fees",
          "block_1_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_global.png",
          "block_2_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gift.png",
          "block_4_heading": "Fan Engagement & Growth",
          "block_4_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_coin.png",
          "block_3_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_flash.png",
          "sk": "SECTION#1781873310755"
        },
        {
          "subheading": "See how TopFan helps creators move beyond locked content with better control, wider monetization, and stronger fan-business tools.",
          "button_text_color": "#ffffff",
          "background_color": "#ffffff",
          "key_win_1_description": "TopFan is completely free for creators and includes a fully white-labeled website and app from day one. Mighty starts at $79/month, never drops its transaction fee to 0%, and reserves a truly unbranded app for its $179+/month Scale plan.",
          "key_win_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__2_.png",
          "key_win_5_title": "Engage Beyond Content Drops",
          "key_win_6_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__5_.png",
          "name": "WHERE TOPFAN WINS",
          "page_id": 1781873303586,
          "key_win_6_description": "TopFan includes a real referral program, ticketing, and brand collaboration tools for every creator, free. Mighty's Partner Program only pays for referring new hosts to Mighty itself — affiliate tools for your own products need a paid upgrade.",
          "key_win_5_description": "TopFan pairs built-in gamification, loyalty rewards, and a true discovery algorithm built to grow your audience. Mighty's gamification is strong, but with no public discovery feed, every bit of growth still falls on the creator's own marketing.",
          "key_win_4_title": "Own the Audience Relationship",
          "section_heading": "Where TopFan wins {over Mighty}",
          "key_win_2_title": "Keep More From Every Sale",
          "key_win_3_description": "TopFan gives you subscriptions, merch, tickets, and ads in one connected platform. Mighty has no native Shopify integration or giveaway tool, leaving creators to bridge through Zapier or sell products outside the platform entirely.",
          "secondary_background_color": "#0f172a",
          "key_win_2_description": "Keep up to 95% of every merch and ticket sale and 85% on subscriptions with TopFan. Mighty stacks a $79–$354+/month software fee with a 0.5–2% transaction fee on top, and refunds never return either cut to you.",
          "key_win_4_description": "Your fans, your data, your relationship — TopFan and Mighty both give creators real ownership of their member data. Only TopFan does it without a recurring software bill and a transaction fee that never goes away.",
          "key_win_6_title": "Built for Long-Term Growth",
          "created_at": 1781873313125,
          "heading_font_size": "medium",
          "background_text_color": "#1e293b",
          "key_win_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__3_.png",
          "theme_color": "#7c3aed",
          "key_win_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956730_featured_icon__1_.png",
          "background_image": null,
          "key_win_1_title": "More Creator Control",
          "updated_at": 1781873313125,
          "key_win_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon.png",
          "post_text_color": "#000000",
          "layout_id": "comparison-key-wins-layout",
          "section_id": 1781873313125,
          "pk": "PAGE#1781873303586",
          "key_win_3_title": "Turn Fans Into Buyers",
          "title": "WHERE TOPFAN WINS",
          "key_win_5_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__4_.png",
          "sk": "SECTION#1781873313125"
        },
        {
          "button_text_color": "#ffffff",
          "row_5_value_2": "Web3 Support",
          "row_4_feature": "Block Users",
          "background_color": "#000000",
          "row_5_value_1": "Web3 Support",
          "row_7_value_2": "Hashtag Search",
          "row_6_feature": "VIP access & ticketing",
          "row_7_value_1": "Hashtag Search",
          "row_1_value_1": "Advanced Insights",
          "row_1_value_2": "Insights Available",
          "row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_status-up.png",
          "row_3_value_1": "Available",
          "row_8_feature": "Fan Rewards",
          "row_3_value_2": "Available",
          "row_12_value_1": "243 Languages",
          "row_10_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_tag.png",
          "row_11_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_color-swatch.png",
          "created_at": 1781873315603,
          "row_11_feature": "Designer Access",
          "row_7_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_hashtag.png",
          "row_12_value_2": "6 Langauges",
          "row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_fi_6699366.png",
          "row_10_value_2": "Not Available",
          "column_2_label": "Mighty",
          "row_6_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_ticket-star.png",
          "background_text_color": "#ffffff",
          "row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-security.png",
          "row_10_value_1": "Available",
          "row_13_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_convertshape-2.png",
          "row_12_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_language-circle.png",
          "row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_user-remove.png",
          "row_9_value_1": "Collab Tools",
          "updated_at": 1781873315603,
          "layout_id": "comparison-full-table-layout",
          "section_id": 1781873315603,
          "row_8_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_award.png",
          "row_9_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_share.png",
          "pk": "PAGE#1781873303586",
          "row_2_feature": "Security Watermarking",
          "row_9_value_2": "Limited",
          "title": "Other Advantages",
          "row_4_value_2": "User Blocking",
          "row_4_value_1": "User Blocking",
          "row_3_feature": "Stream Protection",
          "row_5_feature": "Web3 / NFT Integration",
          "name": "OTHER ADVANTAGES",
          "row_6_value_1": "VIP Tools",
          "row_6_value_2": "VIP Tools",
          "column_1_label": "TOPFAN",
          "page_id": 1781873303586,
          "row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-tick.png",
          "row_9_feature": "Creator Collaborations",
          "section_heading": "Other {Powerful TopFan} Advantages",
          "row_2_value_1": "Watermarking",
          "row_2_value_2": "Not Available",
          "secondary_background_color": "#000000",
          "row_7_feature": "Hashtag Organization",
          "row_13_feature": "Referral Program",
          "row_12_feature": "Auto Translation",
          "row_13_value_2": "Limited",
          "row_13_value_1": "Higher Rewards",
          "heading_font_size": "medium",
          "row_10_feature": "Brand Ads",
          "row_11_value_1": "Coming Soon",
          "theme_color": "#7c3aed",
          "row_11_value_2": "Limited",
          "background_image": null,
          "post_text_color": "#ffffff",
          "row_8_value_2": "Limited",
          "row_8_value_1": "Rewards Supported",
          "row_1_feature": "Rich analytics",
          "section_subheading": "Additional tools that support safety, analytics, automation, and advanced creator workflows.",
          "sk": "SECTION#1781873315603"
        },
        {
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "name": "SUMMARY",
          "summary_heading": "Summary",
          "page_id": 1781873303586,
          "card_b_heading": "Who is Mighty best suited for?",
          "secondary_background_color": "#f7f7f7",
          "created_at": 1781873318031,
          "summary_text": "Mighty pairs solid course tools with a strong native gamification system, but creators pay a $79–$354+/month software fee stacked with a transaction fee. TopFan includes the same gamification and analytics for free, with a fee structure that only takes a share when a creator actually earns.",
          "heading_font_size": "medium",
          "card_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990890588_frame_2147226360__1_.png",
          "card_a_body": "TopFan is built for creators who want to grow beyond exclusive content. Helps creators sell memberships, videos, courses, downloads, merchandise, experiences, and fan access from one platform. TopFan is best suited for creators and creator teams who want stronger fan ownership, deeper engagement, multiple revenue streams, and community-led growth.",
          "background_text_color": "#1b1b1b",
          "card_a_heading": "Who is TopFan best suited for?",
          "theme_color": "#7c3aed",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011808159_background_flare__1_.jpg",
          "updated_at": 1781873318031,
          "post_text_color": "#000000",
          "layout_id": "comparison-audience-summary-layout",
          "section_id": 1781873318031,
          "card_b_body": "Mightyy is suited for hosts running a course-and-community hybrid who want native gamification and a real, if pricier, path to a branded mobile app — its points, badges, and leaderboard system is one of the more developed engagement engines in the category. But every plan carries both a monthly software fee and a transaction cut that never disappears, and there's no public discovery feed to help a creator find new fans, which is exactly where TopFan takes over.",
          "pk": "PAGE#1781873303586",
          "card_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780922932705_group.png",
          "title": "SUMMARY",
          "sk": "SECTION#1781873318031"
        },
        {
          "button_text_color": "#ffffff",
          "testimonial_6_background_image": null,
          "background_color": "#d0e9ee",
          "testimonial_4_creator_type": "Professionals",
          "testimonial_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
          "testimonial_6_name": "The Predictors",
          "testimonial_2_user_name": "julia-kugel",
          "testimonial_6_creator_type": "Organizations",
          "testimonial_4_stars": "5",
          "testimonial_5_name": "Tulsa Bite",
          "testimonial_2_content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
          "testimonial_7_stars": "5",
          "testimonial_5_user_name": "tulsa_bite",
          "testimonial_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
          "testimonial_7_background_image": null,
          "testimonial_title": "Testimonials",
          "created_at": 1781873320617,
          "testimonial_4_background_image": null,
          "testimonial_5_stars": "5",
          "testimonial_1_user_name": "johnward",
          "background_text_color": "#000000",
          "testimonial_5_content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space.",
          "updated_at": 1781873320617,
          "testimonial_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
          "layout_id": "testimonial-layout",
          "section_id": 1781873320617,
          "testimonial_7_redirection_link": "https://www.markschlereth.fans/",
          "testimonial_1_stars": "5",
          "testimonial_4_user_name": "davidgold",
          "testimonial_2_redirection_link": "https://www.juliajulia.fans/",
          "pk": "PAGE#1781873303586",
          "testimonial_7_content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform.",
          "testimonial_5_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
          "title": "TESTIMONIALS",
          "testimonial_3_name": "Katrina Darling Friedman",
          "testimonial_7_user_name": "markschlereth",
          "testimonial_6_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
          "testimonial_5_creator_type": "Creator and Influencer",
          "testimonial_1_background_image": null,
          "testimonial_3_redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
          "name": "TESTIMONIALS",
          "testimonial_7_creator_type": "Athletes",
          "testimonial_3_user_name": "katrinadarlingfriedman",
          "testimonial_3_content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
          "page_id": 1781873303586,
          "testimonial_3_background_image": null,
          "section_heading": "More than {1,000} Creators Have Trusted Us Since We Started.",
          "testimonial_4_redirection_link": "https://www.goldweatherkingdom.com/",
          "testimonial_2_background_image": null,
          "testimonial_5_redirection_link": "https://www.topfan.com/tulsa_bite",
          "testimonial_1_content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
          "secondary_background_color": "#000000",
          "testimonial_2_stars": "5",
          "testimonial_2_name": "Julia Julia",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "johnward",
              "name": "John Ward",
              "redirection_link": "https://www.topfan.com/johnward",
              "stars": "5",
              "content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
              "creator_type": "Musicians",
              "user_name": "julia-kugel",
              "name": "Julia Julia",
              "redirection_link": "https://www.juliajulia.fans/",
              "stars": "5",
              "content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!"
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "katrinadarlingfriedman",
              "name": "Katrina Darling Friedman",
              "redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
              "stars": "5",
              "content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
              "creator_type": "Professionals",
              "user_name": "davidgold",
              "name": "David Gold",
              "redirection_link": "https://www.goldweatherkingdom.com/",
              "stars": "5",
              "content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
              "creator_type": "Creator and Influencer",
              "user_name": "tulsa_bite",
              "name": "Tulsa Bite",
              "redirection_link": "https://www.topfan.com/tulsa_bite",
              "stars": "5",
              "content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
              "creator_type": "Organizations",
              "user_name": "the-predictors",
              "name": "The Predictors",
              "redirection_link": "https://www.thepredictors.fans/",
              "stars": "5",
              "content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
              "creator_type": "Athletes",
              "user_name": "markschlereth",
              "name": "Mark Schlereth",
              "redirection_link": "https://www.markschlereth.fans/",
              "stars": "5",
              "content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform."
            }
          ],
          "testimonial_6_redirection_link": "https://www.thepredictors.fans/",
          "testimonial_6_user_name": "the-predictors",
          "testimonial_6_content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers.",
          "heading_font_size": "medium",
          "testimonial_1_redirection_link": "https://www.topfan.com/johnward",
          "testimonial_3_stars": "5",
          "testimonial_7_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
          "testimonial_1_name": "John Ward",
          "testimonial_4_content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.",
          "testimonial_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
          "theme_color": "#141515",
          "testimonial_5_background_image": null,
          "post_text_color": "#ffffff",
          "testimonial_6_stars": "5",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_4_name": "David Gold",
          "testimonial_1_creator_type": "Food, Fitness and Wellness",
          "testimonial_7_name": "Mark Schlereth",
          "testimonial_3_creator_type": "Food, Fitness and Wellness",
          "sk": "SECTION#1781873320617"
        }
      ]
    }
  },
  "topfan-vs-passes": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "seoKeywords": "topfan vs passes, passes app alternative, creator monetization platform, own branded fan platform, passes pricing comparison, creator accelerator alternative",
      "competitor_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780989722423_frame_2147226361.png",
      "status": "PUBLISHED",
      "post_text_color": "#ffffff",
      "sk": "PAGE#1781872788945",
      "background_color": "#000000",
      "updated_at": 1781872788945,
      "page_id": 1781872788945,
      "url": "topfan-vs-passes",
      "pk": "MARKETINGPAGE",
      "meta_description": "Compare TopFan and Passes on fees, branding, and fan data ownership.",
      "title": "Passes",
      "meta_title": "TopFan vs Passes: Which Is the Better Platform in 2026?",
      "secondary_background_color": "#000000",
      "type": "MARKETING_COMPARISON",
      "button_text_color": "#ffffff",
      "text_color": "#000000",
      "created_at": 1781872788945,
      "gsi1sk": "PAGE#1781872788945",
      "sequence_number": 7,
      "gsi1pk": "topfan-vs-passes",
      "background_text_color": "#ffffff",
      "sections": [
        {
          "subheading": "A creator-first platform helping you grow, engage, and earn through subscriptions, content, and live experiences — all on your own branded site and app, not Passes'.",
          "button_text_color": "#ffffff",
          "created_at": 1781872791346,
          "competitor_name": "Passes",
          "background_color": "#ffffff",
          "heading_font_size": "large",
          "background_text_color": "#000000",
          "theme_color": "#7c3aed",
          "name": "HERO PAGE",
          "platform_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780920210571_group.png",
          "background_image": null,
          "updated_at": 1781872791346,
          "page_id": 1781872788945,
          "post_text_color": "#000000",
          "layout_id": "comparison-hero-layout",
          "section_id": 1781872791346,
          "section_heading": "{TopFan vs Passes: Which is the better platform?}",
          "secondary_background_color": "#000000",
          "platform_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990667048_frame_2147226361.png",
          "pk": "PAGE#1781872788945",
          "title": "Hero Page",
          "sk": "SECTION#1781872791346"
        },
        {
          "subheading": "TopFans gives creators the tools to monetize, engage, grow, & manage their fan business.",
          "value_card_1_description": "Sell memberships, exclusive content, tips, paid DMs, merchandise, courses, and experiences from one platform.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "value_card_3_description": "Grow beyond social media with discovery tools, referrals, loyal fan rewards, and brand partnership opportunities.",
          "value_card_4_description": "Own your fan data, track content performance, manage access, and protect your content with built-in safety tools.",
          "name": "WHY CHOOSE TOPFAN",
          "page_id": 1781872788945,
          "value_card_2_title": "Deeper Fan Engagement",
          "section_heading": "{Why Choose TopFan?}",
          "value_card_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_message-chat-circle.png",
          "secondary_background_color": "#1f1f1e",
          "value_card_2_description": "Build stronger relationships through direct messages, polls, private communities, rewards, and personalized fan interactions.",
          "created_at": 1781872793746,
          "value_card_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-04.png",
          "heading_font_size": "medium",
          "value_card_4_title": "Full Control & Insights",
          "background_text_color": "#ffffff",
          "theme_color": "#5e00ff",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1780920467614_cb2078a3a11ac679ddb58d9cc8cf4c8bef941e9d__1_.png",
          "updated_at": 1781872793746,
          "post_text_color": "#ffffff",
          "layout_id": "comparison-value-grid-layout",
          "section_id": 1781872793746,
          "value_card_3_title": "Creator-Led Growth",
          "value_card_1_title": "More Ways to Earn",
          "value_card_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-03.png",
          "pk": "PAGE#1781872788945",
          "title": "WHY CHOOSE TOPFAN",
          "value_card_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_line-chart-up-03.png",
          "sk": "SECTION#1781872793746"
        },
        {
          "block_2_image_position": "left",
          "button_text_color": "#ffffff",
          "block_1_row_4_value_competitor": "Limited Control",
          "background_color": "#ffffff",
          "block_4_row_1_feature": "Discovery Algorithm",
          "block_2_row_2_feature": "Tips on content & DMs",
          "block_4_row_1_value_competitor": "Built-in Discovery",
          "block_4_row_5_feature": "Loyalty Gamification",
          "block_3_row_1_value_topfan": "Media Selling",
          "block_3_row_2_value_topfan": "Audio Selling",
          "block_4_row_5_value_topfan": "Loyalty Tools",
          "block_4_row_4_value_topfan": "Supported",
          "block_2_row_2_value_topfan": "Tips Supported",
          "created_at": 1781872796146,
          "block_2_row_3_value_topfan": "Locked DMs",
          "block_1_row_3_value_topfan": "Custom URL",
          "block_3_row_3_feature": "Online Courses",
          "block_1_row_4_value_topfan": "Full Ownership",
          "block_1_row_2_value_competitor": "No Fan Fee",
          "block_1_heading": "Creator Setup & Control",
          "block_3_row_5_value_topfan": "Experiences Selling",
          "layout_id": "comparison-feature-section-layout",
          "block_3_row_1_value_competitor": "Media Selling",
          "block_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__1_.png",
          "block_1_row_4_feature": "Fan Data Ownership",
          "subheading": "A full-stack online community platform designed for flexibility and scalability, empowering organizations to build, manage, and engage communities with ease.",
          "block_2_row_2_value_competitor": "Tips Supported",
          "block_4_row_4_feature": "Polls",
          "block_1_row_5_feature": "Publishing Scheduler",
          "block_2_row_1_feature": "Membership Tiers",
          "name": "COMMUNITY BUILDER",
          "page_id": 1781872788945,
          "block_1_image_position": "right",
          "section_heading": "{TopFan} is more than a Community Builder",
          "block_1_row_1_value_topfan": "5-15% plus standard 3rd party credit card fees",
          "block_2_row_5_feature": "Prize Giveaway",
          "block_4_row_1_value_topfan": "Built-in Discovery",
          "competitor_column_label": "Passes",
          "block_3_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_document-download.png",
          "block_2_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like.png",
          "block_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_content.png",
          "block_3_row_2_value_competitor": "Audio Selling",
          "block_4_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like__1_.png",
          "block_4_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_messages-2.png",
          "heading_font_size": "medium",
          "block_4_row_5_value_competitor": "Not Available",
          "block_3_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_musicnote.png",
          "block_1_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_receipt-2.png",
          "block_1_row_1_feature": "Creator Platform Fee",
          "theme_color": "#000000",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011654314_background_flare__1_.jpg",
          "post_text_color": "#000000",
          "block_2_heading": "Monetization & Selling",
          "block_3_row_4_feature": "Downloadable Content",
          "block_3_row_5_value_competitor": "Experiences",
          "block_2_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_star.png",
          "block_1_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_key.png",
          "block_4_row_2_value_competitor": "Not available",
          "block_4_row_3_feature": "Private Chat Rooms",
          "block_2_row_4_feature": "Shopify Supported",
          "block_1_row_3_value_competitor": "Not Available",
          "block_2_row_5_value_competitor": "Not Available",
          "topfan_column_label": "TopFan",
          "block_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__2_.png",
          "block_2_row_1_value_topfan": "Supported",
          "block_3_row_1_feature": "Videos & Galleries",
          "block_3_row_4_value_topfan": "Downloadable Selling",
          "block_4_row_2_value_topfan": "Supported",
          "block_1_row_2_value_topfan": "No Fan Fee",
          "block_4_row_3_value_topfan": "Supported",
          "block_3_row_3_value_topfan": "Course Selling",
          "block_4_row_4_value_competitor": "Not Available",
          "block_4_description": "Build stronger fan relationships through interaction, discovery, and loyalty tools.",
          "block_2_row_4_value_topfan": "Supported",
          "background_text_color": "#000000",
          "block_3_description": "Sell different content formats from one creator storefront.",
          "block_1_description": "Set up, customize, and manage your creator presence with more ownership.",
          "block_2_row_5_value_topfan": "Giveaway Tools",
          "block_1_row_5_value_topfan": "Supported",
          "block_2_description": "Give creators more ways to earn through content, access, and fan purchases.",
          "updated_at": 1781872796146,
          "block_2_row_3_value_competitor": "Locked DMs",
          "block_1_row_2_feature": "Fan Platform Fee",
          "section_id": 1781872796146,
          "block_3_image_position": "right",
          "block_3_heading": "Content Commerce",
          "block_1_row_5_value_competitor": "Supported",
          "block_4_image_position": "left",
          "pk": "PAGE#1781872788945",
          "block_3_row_5_feature": "Experiences",
          "title": "COMMUNITY BUILDER",
          "block_4_row_2_feature": "Targeted Outreach",
          "block_3_row_4_value_competitor": "Downloadable Selling",
          "block_3_row_3_value_competitor": "Course Selling",
          "block_2_row_3_feature": "Paid / Locked DMs",
          "secondary_background_color": "#000000",
          "block_2_row_1_value_competitor": "Supported",
          "block_3_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_teacher.png",
          "block_2_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_sms-star.png",
          "block_1_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_money.png",
          "block_2_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_crown.png",
          "block_4_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_shield-tick.png",
          "block_2_row_4_value_competitor": "Supported",
          "block_4_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_code-circle.png",
          "block_3_row_2_feature": "Audio & Music",
          "block_3_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gallery.png",
          "block_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__3_.png",
          "block_1_row_3_feature": "Custom Website URL",
          "block_4_row_3_value_competitor": "Supported",
          "block_1_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_send-2.png",
          "block_1_row_1_value_competitor": "10% fee plus standard 3rd party credit card fees",
          "block_1_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_global.png",
          "block_2_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gift.png",
          "block_4_heading": "Fan Engagement & Growth",
          "block_4_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_coin.png",
          "block_3_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_flash.png",
          "sk": "SECTION#1781872796146"
        },
        {
          "subheading": "See how TopFans helps creators move beyond locked content with better control, wider monetization, and stronger fan-business tools.",
          "button_text_color": "#ffffff",
          "background_color": "#ffffff",
          "key_win_1_description": "TopFans gives creators custom URLs, fan data ownership, and stronger control over how they manage their fan business.",
          "key_win_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__2_.png",
          "key_win_5_title": "Engage Beyond Content Drops",
          "key_win_6_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__5_.png",
          "name": "WHERE TOPFAN WINS",
          "page_id": 1781872788945,
          "key_win_6_description": "TopFans supports creator growth through discovery, referrals, loyalty rewards, VIP access, brand opportunities, and advanced fan insights.",
          "key_win_5_description": "TopFans helps creators build stronger fan relationships through polls, private rooms, rewards, targeted messages, and paid interactions.",
          "key_win_4_title": "Own the Audience Relationship",
          "section_heading": "Where TopFan wins {over Passes}",
          "key_win_2_title": "Keep More From Every Sale",
          "key_win_3_description": "TopFans lets creators sell more than posts — including merchandise, courses, downloads, audio, experiences, and premium content collections.",
          "secondary_background_color": "#0f172a",
          "key_win_2_description": "TopFans offers a more creator-friendly fee structure, helping creators retain more value from memberships, paid content, and fan transactions.",
          "key_win_4_description": "With fan data ownership, segmentation, and export options, TopFans gives creators more control over their audience beyond the platform.",
          "key_win_6_title": "Built for Long-Term Growth",
          "created_at": 1781872798517,
          "heading_font_size": "medium",
          "background_text_color": "#1e293b",
          "key_win_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__3_.png",
          "theme_color": "#7c3aed",
          "key_win_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956730_featured_icon__1_.png",
          "key_win_1_title": "More Creator Control",
          "updated_at": 1781872798517,
          "key_win_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon.png",
          "post_text_color": "#000000",
          "layout_id": "comparison-key-wins-layout",
          "section_id": 1781872798517,
          "pk": "PAGE#1781872788945",
          "key_win_3_title": "Turn Fans Into Buyers",
          "title": "WHERE TOPFAN WINS",
          "key_win_5_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__4_.png",
          "sk": "SECTION#1781872798517"
        },
        {
          "button_text_color": "#ffffff",
          "row_5_value_2": "Not Available",
          "row_4_feature": "Block Users",
          "background_color": "#000000",
          "row_5_value_1": "Web3 Support",
          "row_7_value_2": "Not Available",
          "row_6_feature": "VIP access & ticketing",
          "row_7_value_1": "Hashtag Search",
          "row_1_value_1": "Advanced Insights",
          "row_1_value_2": "Basic Analytics",
          "row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_status-up.png",
          "row_3_value_1": "Available",
          "row_8_feature": "Fan Rewards",
          "row_3_value_2": "Available",
          "row_12_value_1": "243 Languages",
          "row_10_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_tag.png",
          "row_11_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_color-swatch.png",
          "created_at": 1781872800878,
          "row_11_feature": "Designer Access",
          "row_7_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_hashtag.png",
          "row_12_value_2": "Not Available",
          "row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_fi_6699366.png",
          "row_10_value_2": "Not Available",
          "column_2_label": "Passes",
          "row_6_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_ticket-star.png",
          "background_text_color": "#ffffff",
          "row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-security.png",
          "row_10_value_1": "Available",
          "row_13_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_convertshape-2.png",
          "row_12_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_language-circle.png",
          "row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_user-remove.png",
          "row_9_value_1": "Collab Tools",
          "updated_at": 1781872800878,
          "layout_id": "comparison-full-table-layout",
          "section_id": 1781872800878,
          "row_8_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_award.png",
          "row_9_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_share.png",
          "pk": "PAGE#1781872788945",
          "row_2_feature": "Security Watermarking",
          "row_9_value_2": "Not Available",
          "title": "Other Advantages",
          "row_4_value_2": "User Blocking",
          "row_4_value_1": "User Blocking",
          "row_3_feature": "Stream Protection",
          "row_5_feature": "Web3 / NFT Integration",
          "name": "OTHER ADVANTAGES",
          "row_6_value_1": "VIP Tools",
          "row_6_value_2": "Not Available",
          "column_1_label": "TOPFAN",
          "page_id": 1781872788945,
          "row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-tick.png",
          "row_9_feature": "Creator Collaborations",
          "section_heading": "Other {Powerful TopFan} Advantages",
          "row_2_value_1": "Watermarking",
          "row_2_value_2": "Watermarking",
          "secondary_background_color": "#000000",
          "row_7_feature": "Hashtag Organization",
          "row_13_feature": "Referral Program",
          "row_12_feature": "Auto Translation",
          "row_13_value_2": "Not Available",
          "row_13_value_1": "Higher Rewards",
          "heading_font_size": "medium",
          "row_10_feature": "Brand Ads",
          "row_11_value_1": "Coming Soon",
          "theme_color": "#7c3aed",
          "row_11_value_2": "Not Available",
          "background_image": null,
          "post_text_color": "#ffffff",
          "row_8_value_2": "Not Available",
          "row_8_value_1": "Rewards Supported",
          "row_1_feature": "Rich analytics",
          "section_subheading": "Additional tools that support safety, analytics, automation, and advanced creator workflows.",
          "sk": "SECTION#1781872800878"
        },
        {
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "name": "SUMMARY",
          "summary_heading": "Summary",
          "page_id": 1781872788945,
          "card_b_heading": "Who is Passes best suited for?",
          "secondary_background_color": "#f7f7f7",
          "created_at": 1781872803269,
          "summary_text": "Passes offers more monetization flexibility than many creator platforms, with a 10% fee, anti-screenshot DRM, and digital product sales built in. But it still operates as a closed platform — your audience lives on Passes' infrastructure, under their domain, and you don't own your fan data. \n\nTopFan is built around the opposite model: your own branded site, your own URL, full fan data ownership, and a broader toolkit that includes courses, experiences, loyalty tools, and community-led growth — without giving up control to a third-party platform.",
          "heading_font_size": "medium",
          "card_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990681589_frame_2147226361.png",
          "card_a_body": "TopFan is built for creators who want to grow beyond exclusive content. Helps creators sell memberships, videos, courses, downloads, merchandise, experiences, and fan access from one platform. TopFan is best suited for creators and creator teams who want stronger fan ownership, deeper engagement, multiple revenue streams, and community-led growth.",
          "background_text_color": "#1b1b1b",
          "card_a_heading": "Who is TopFan best suited for?",
          "theme_color": "#7c3aed",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011640635_background_flare__1_.jpg",
          "updated_at": 1781872803269,
          "post_text_color": "#000000",
          "layout_id": "comparison-audience-summary-layout",
          "section_id": 1781872803269,
          "card_b_body": "Passes is best suited for established creators who want a monetization-focused platform with subscriptions, paid DMs, and digital product sales. It works well for influencers with an existing audience who want multiple revenue streams and strong content protection. However, creators who need a custom-branded destination, full fan data ownership, course-building tools, loyalty gamification, or community-led growth features will find Passes falls short of a complete creator business platform.",
          "pk": "PAGE#1781872788945",
          "card_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780922932705_group.png",
          "title": "SUMMARY",
          "sk": "SECTION#1781872803269"
        },
        {
          "button_text_color": "#ffffff",
          "testimonial_6_background_image": null,
          "background_color": "#d0e9ee",
          "testimonial_4_creator_type": "Professionals",
          "testimonial_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
          "testimonial_6_name": "The Predictors",
          "testimonial_2_user_name": "julia-kugel",
          "testimonial_6_creator_type": "Organizations",
          "testimonial_4_stars": "5",
          "testimonial_5_name": "Tulsa Bite",
          "testimonial_2_content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
          "testimonial_7_stars": "5",
          "testimonial_5_user_name": "tulsa_bite",
          "testimonial_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
          "testimonial_7_background_image": null,
          "testimonial_title": "Testimonials",
          "created_at": 1781872805634,
          "testimonial_4_background_image": null,
          "testimonial_5_stars": "5",
          "testimonial_1_user_name": "johnward",
          "background_text_color": "#000000",
          "testimonial_5_content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space.",
          "updated_at": 1781872805634,
          "testimonial_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
          "layout_id": "testimonial-layout",
          "section_id": 1781872805634,
          "testimonial_7_redirection_link": "https://www.markschlereth.fans/",
          "testimonial_1_stars": "5",
          "testimonial_4_user_name": "davidgold",
          "testimonial_2_redirection_link": "https://www.juliajulia.fans/",
          "pk": "PAGE#1781872788945",
          "testimonial_7_content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform.",
          "testimonial_5_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
          "title": "TESTIMONIALS",
          "testimonial_3_name": "Katrina Darling Friedman",
          "testimonial_7_user_name": "markschlereth",
          "testimonial_6_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
          "testimonial_5_creator_type": "Creator and Influencer",
          "testimonial_1_background_image": null,
          "testimonial_3_redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
          "name": "TESTIMONIALS",
          "testimonial_7_creator_type": "Athletes",
          "testimonial_3_user_name": "katrinadarlingfriedman",
          "testimonial_3_content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
          "page_id": 1781872788945,
          "testimonial_3_background_image": null,
          "section_heading": "More than {1,000} Creators Have Trusted Us Since We Started.",
          "testimonial_4_redirection_link": "https://www.goldweatherkingdom.com/",
          "testimonial_2_background_image": null,
          "testimonial_5_redirection_link": "https://www.topfan.com/tulsa_bite",
          "testimonial_1_content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
          "secondary_background_color": "#000000",
          "testimonial_2_stars": "5",
          "testimonial_2_name": "Julia Julia",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "johnward",
              "name": "John Ward",
              "redirection_link": "https://www.topfan.com/johnward",
              "stars": "5",
              "content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
              "creator_type": "Musicians",
              "user_name": "julia-kugel",
              "name": "Julia Julia",
              "redirection_link": "https://www.juliajulia.fans/",
              "stars": "5",
              "content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!"
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "katrinadarlingfriedman",
              "name": "Katrina Darling Friedman",
              "redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
              "stars": "5",
              "content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
              "creator_type": "Professionals",
              "user_name": "davidgold",
              "name": "David Gold",
              "redirection_link": "https://www.goldweatherkingdom.com/",
              "stars": "5",
              "content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
              "creator_type": "Creator and Influencer",
              "user_name": "tulsa_bite",
              "name": "Tulsa Bite",
              "redirection_link": "https://www.topfan.com/tulsa_bite",
              "stars": "5",
              "content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
              "creator_type": "Organizations",
              "user_name": "the-predictors",
              "name": "The Predictors",
              "redirection_link": "https://www.thepredictors.fans/",
              "stars": "5",
              "content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
              "creator_type": "Athletes",
              "user_name": "markschlereth",
              "name": "Mark Schlereth",
              "redirection_link": "https://www.markschlereth.fans/",
              "stars": "5",
              "content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform."
            }
          ],
          "testimonial_6_redirection_link": "https://www.thepredictors.fans/",
          "testimonial_6_user_name": "the-predictors",
          "testimonial_6_content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers.",
          "heading_font_size": "medium",
          "testimonial_1_redirection_link": "https://www.topfan.com/johnward",
          "testimonial_3_stars": "5",
          "testimonial_7_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
          "testimonial_1_name": "John Ward",
          "testimonial_4_content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.",
          "testimonial_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
          "theme_color": "#141515",
          "testimonial_5_background_image": null,
          "post_text_color": "#ffffff",
          "testimonial_6_stars": "5",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_4_name": "David Gold",
          "testimonial_1_creator_type": "Food, Fitness and Wellness",
          "testimonial_7_name": "Mark Schlereth",
          "testimonial_3_creator_type": "Food, Fitness and Wellness",
          "sk": "SECTION#1781872805634"
        }
      ]
    }
  },
  "topfan-vs-patreon": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "competitor_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780989790731_frame_2147226356.png",
      "background_text_color": "#ffffff",
      "gsi1sk": "PAGE#1781873455444",
      "gsi1pk": "topfan-vs-patreon",
      "created_at": 1781873455444,
      "pk": "MARKETINGPAGE",
      "button_text_color": "#ffffff",
      "status": "PUBLISHED",
      "seoKeywords": "topfan vs patreon, patreon alternative, creator subscription platform, fan club platform for creators, patreon comparison, best membership platform for creators",
      "background_color": "#000000",
      "title": "Patreon",
      "text_color": "#000000",
      "updated_at": 1781873455444,
      "page_id": 1781873455444,
      "meta_description": "Compare TopFan vs Patreon: fees, fan data ownership, custom branding, and monetization tools. See why creators looking for a Patreon alternative are choosing TopFan to build their own branded community.",
      "url": "topfan-vs-patreon",
      "secondary_background_color": "#000000",
      "meta_title": "TopFan vs Patreon: Which is the better platform?",
      "post_text_color": "#ffffff",
      "sk": "PAGE#1781873455444",
      "sequence_number": 1,
      "type": "MARKETING_COMPARISON",
      "sections": [
        {
          "subheading": "TopFan gives creators a custom-branded platform with memberships, courses, experiences, and full audience ownership — while Patreon limits you to subscriptions on a page that lives on their site, not yours.",
          "button_text_color": "#ffffff",
          "created_at": 1781873457842,
          "competitor_name": "Patreon",
          "background_color": "#ffffff",
          "heading_font_size": "large",
          "background_text_color": "#000000",
          "theme_color": "#7c3aed",
          "name": "HERO PAGE",
          "platform_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780920210571_group.png",
          "background_image": null,
          "updated_at": 1781873457842,
          "page_id": 1781873455444,
          "post_text_color": "#000000",
          "layout_id": "comparison-hero-layout",
          "section_id": 1781873457842,
          "section_heading": "{TopFan vs Patreon: Which is the better platform?}",
          "secondary_background_color": "#000000",
          "platform_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990752436_frame_2147226356.png",
          "pk": "PAGE#1781873455444",
          "title": "Hero Page",
          "sk": "SECTION#1781873457842"
        },
        {
          "subheading": "TopFans gives creators the tools to monetize, engage, grow, & manage their fan business.",
          "value_card_1_description": "Sell memberships, exclusive content, tips, paid DMs, merchandise, courses, and experiences from one platform.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "value_card_3_description": "Grow beyond social media with discovery tools, referrals, loyal fan rewards, and brand partnership opportunities.",
          "value_card_4_description": "Own your fan data, track content performance, manage access, and protect your content with built-in safety tools.",
          "name": "WHY CHOOSE TOPFAN",
          "page_id": 1781873455444,
          "value_card_2_title": "Deeper Fan Engagement",
          "section_heading": "{Why Choose TopFan?}",
          "value_card_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_message-chat-circle.png",
          "secondary_background_color": "#1f1f1e",
          "value_card_2_description": "Build stronger relationships through direct messages, polls, private communities, rewards, and personalized fan interactions.",
          "created_at": 1781873460204,
          "value_card_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-04.png",
          "heading_font_size": "medium",
          "value_card_4_title": "Full Control & Insights",
          "background_text_color": "#ffffff",
          "theme_color": "#5e00ff",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1780920467614_cb2078a3a11ac679ddb58d9cc8cf4c8bef941e9d__1_.png",
          "updated_at": 1781873460204,
          "post_text_color": "#ffffff",
          "layout_id": "comparison-value-grid-layout",
          "section_id": 1781873460204,
          "value_card_3_title": "Creator-Led Growth",
          "value_card_1_title": "More Ways to Earn",
          "value_card_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-03.png",
          "pk": "PAGE#1781873455444",
          "title": "WHY CHOOSE TOPFAN",
          "value_card_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_line-chart-up-03.png",
          "sk": "SECTION#1781873460204"
        },
        {
          "block_2_image_position": "left",
          "button_text_color": "#ffffff",
          "block_1_row_4_value_competitor": "Limited Control",
          "background_color": "#ffffff",
          "block_4_row_1_feature": "Discovery Algorithm",
          "block_2_row_2_feature": "Tips on content & DMs",
          "block_4_row_1_value_competitor": "Limited - Not personalized",
          "block_4_row_5_feature": "Loyalty Gamification",
          "block_3_row_1_value_topfan": "Media Selling",
          "block_3_row_2_value_topfan": "Audio Selling",
          "block_4_row_5_value_topfan": "Loyalty Tools",
          "block_4_row_4_value_topfan": "Supported",
          "block_2_row_2_value_topfan": "Tips Supported",
          "created_at": 1781873462621,
          "block_2_row_3_value_topfan": "Locked DMs",
          "block_1_row_3_value_topfan": "Custom URL",
          "block_3_row_3_feature": "Online Courses",
          "block_1_row_4_value_topfan": "Full Ownership",
          "block_1_row_2_value_competitor": "Fan Fee Applies",
          "block_1_heading": "Creator Setup & Control",
          "block_3_row_5_value_topfan": "Experience Selling",
          "layout_id": "comparison-feature-section-layout",
          "block_3_row_1_value_competitor": "Media Selling",
          "block_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__1_.png",
          "block_1_row_4_feature": "Fan Data Ownership",
          "subheading": "A full-stack online community platform designed for flexibility and scalability, empowering organizations to build, manage, and engage communities with ease.",
          "block_2_row_2_value_competitor": "Limited Support",
          "block_4_row_4_feature": "Polls",
          "block_1_row_5_feature": "Publishing Scheduler",
          "block_2_row_1_feature": "Membership Tiers",
          "name": "COMMUNITY BUILDER",
          "page_id": 1781873455444,
          "block_1_image_position": "right",
          "section_heading": "{TopFan} is more than a Community Builder",
          "block_1_row_1_value_topfan": "5-15% plus standard 3rd party credit card fees",
          "block_2_row_5_feature": "Prize Giveaway",
          "block_4_row_1_value_topfan": "Built-in Discovery",
          "competitor_column_label": "Patreon",
          "block_3_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_document-download.png",
          "block_2_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like.png",
          "block_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_content.png",
          "block_3_row_2_value_competitor": "Audio Selling",
          "block_4_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like__1_.png",
          "block_4_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_messages-2.png",
          "heading_font_size": "medium",
          "block_4_row_5_value_competitor": "Not Available",
          "block_3_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_musicnote.png",
          "block_1_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_receipt-2.png",
          "block_1_row_1_feature": "Creator Platform Fee",
          "theme_color": "#000000",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011716573_background_flare__1_.jpg",
          "post_text_color": "#000000",
          "block_2_heading": "Monetization & Selling",
          "block_3_row_4_feature": "Downloadable Content",
          "block_3_row_5_value_competitor": "Experience Selling",
          "block_2_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_star.png",
          "block_1_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_key.png",
          "block_4_row_2_value_competitor": "Not Available",
          "block_4_row_3_feature": "Private Chat Rooms",
          "block_2_row_4_feature": "Shopify Supported",
          "block_1_row_3_value_competitor": "Not Available",
          "block_2_row_5_value_competitor": "Not Available",
          "topfan_column_label": "TopFan",
          "block_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__2_.png",
          "block_2_row_1_value_topfan": "Supported",
          "block_3_row_1_feature": "Videos & Galleries",
          "block_3_row_4_value_topfan": "Downloadable Selling",
          "block_4_row_2_value_topfan": "Supported",
          "block_1_row_2_value_topfan": "No Fan Fee",
          "block_4_row_3_value_topfan": "Supported",
          "block_3_row_3_value_topfan": "Course Selling",
          "block_4_row_4_value_competitor": "Supported",
          "block_4_description": "Build stronger fan relationships through interaction, discovery, and loyalty tools.",
          "block_2_row_4_value_topfan": "Supported",
          "background_text_color": "#000000",
          "block_3_description": "Sell different content formats from one creator storefront.",
          "block_1_description": "Set up, customize, and manage your creator presence with more ownership.",
          "block_2_row_5_value_topfan": "Giveaway Tools",
          "block_1_row_5_value_topfan": "Supported",
          "block_2_description": "Give creators more ways to earn through content, access, and fan purchases.",
          "updated_at": 1781873462621,
          "block_2_row_3_value_competitor": "Locked DMs",
          "block_1_row_2_feature": "Fan Platform Fee",
          "section_id": 1781873462621,
          "block_3_image_position": "right",
          "block_3_heading": "Content Commerce",
          "block_1_row_5_value_competitor": "Supported",
          "block_4_image_position": "left",
          "pk": "PAGE#1781873455444",
          "block_3_row_5_feature": "Experiences",
          "title": "COMMUNITY BUILDER",
          "block_4_row_2_feature": "Targeted Outreach",
          "block_3_row_4_value_competitor": "Supported",
          "block_3_row_3_value_competitor": "Not Available",
          "block_2_row_3_feature": "Paid / Locked DMs",
          "secondary_background_color": "#000000",
          "block_2_row_1_value_competitor": "Limited Tiers",
          "block_3_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_teacher.png",
          "block_2_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_sms-star.png",
          "block_1_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_money.png",
          "block_2_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_crown.png",
          "block_4_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_shield-tick.png",
          "block_2_row_4_value_competitor": "Not natively supported",
          "block_4_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_code-circle.png",
          "block_3_row_2_feature": "Audio & Music",
          "block_3_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gallery.png",
          "block_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__3_.png",
          "block_1_row_3_feature": "Custom Website URL",
          "block_4_row_3_value_competitor": "Supported",
          "block_1_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_send-2.png",
          "block_1_row_1_value_competitor": "10-14% Fee plus standard 3rd party credit card fees",
          "block_1_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_global.png",
          "block_2_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gift.png",
          "block_4_heading": "Fan Engagement & Growth",
          "block_4_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_coin.png",
          "block_3_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_flash.png",
          "sk": "SECTION#1781873462621"
        },
        {
          "subheading": "See how TopFans helps creators move beyond locked content with better control, wider monetization, and stronger fan-business tools.",
          "button_text_color": "#ffffff",
          "background_color": "#ffffff",
          "key_win_1_description": "TopFans gives creators custom URLs, fan data ownership, and stronger control over how they manage their fan business.",
          "key_win_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__2_.png",
          "key_win_5_title": "Engage Beyond Content Drops",
          "key_win_6_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__5_.png",
          "name": "WHERE TOPFAN WINS",
          "page_id": 1781873455444,
          "key_win_6_description": "TopFans supports creator growth through discovery, referrals, loyalty rewards, VIP access, brand opportunities, and advanced fan insights.",
          "key_win_5_description": "TopFans helps creators build stronger fan relationships through polls, private rooms, rewards, targeted messages, and paid interactions.",
          "key_win_4_title": "Own the Audience Relationship",
          "section_heading": "Where TopFan wins {over Patreon}",
          "key_win_2_title": "Keep More From Every Sale",
          "key_win_3_description": "TopFans lets creators sell more than posts — including merchandise, courses, downloads, audio, experiences, and premium content collections.",
          "secondary_background_color": "#0f172a",
          "key_win_2_description": "TopFans offers a more creator-friendly fee structure, helping creators retain more value from memberships, paid content, and fan transactions.",
          "key_win_4_description": "With fan data ownership, segmentation, and export options, TopFans gives creators more control over their audience beyond the platform.",
          "key_win_6_title": "Built for Long-Term Growth",
          "created_at": 1781873465005,
          "heading_font_size": "medium",
          "background_text_color": "#1e293b",
          "key_win_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__3_.png",
          "theme_color": "#7c3aed",
          "key_win_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956730_featured_icon__1_.png",
          "key_win_1_title": "More Creator Control",
          "updated_at": 1781873465005,
          "key_win_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon.png",
          "post_text_color": "#000000",
          "layout_id": "comparison-key-wins-layout",
          "section_id": 1781873465005,
          "pk": "PAGE#1781873455444",
          "key_win_3_title": "Turn Fans Into Buyers",
          "title": "WHERE TOPFAN WINS",
          "key_win_5_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__4_.png",
          "sk": "SECTION#1781873465005"
        },
        {
          "button_text_color": "#ffffff",
          "row_5_value_2": "Not Available",
          "row_4_feature": "Block Users",
          "background_color": "#000000",
          "row_5_value_1": "Web3 Support",
          "row_7_value_2": "Tags Only",
          "row_6_feature": "VIP access & ticketing",
          "row_7_value_1": "Hashtag Search",
          "row_1_value_1": "Advanced Insights",
          "row_1_value_2": "Basic Insights",
          "row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_status-up.png",
          "row_3_value_1": "Available",
          "row_8_feature": "Fan Rewards",
          "row_3_value_2": "Not Available",
          "row_12_value_1": "243 Languages",
          "row_10_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_tag.png",
          "row_11_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_color-swatch.png",
          "created_at": 1781873467362,
          "row_11_feature": "Designer Access",
          "row_7_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_hashtag.png",
          "row_12_value_2": "Not Available",
          "row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_fi_6699366.png",
          "row_10_value_2": "Not Available",
          "column_2_label": "Patreon",
          "row_6_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_ticket-star.png",
          "background_text_color": "#ffffff",
          "row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-security.png",
          "row_10_value_1": "Available",
          "row_13_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_convertshape-2.png",
          "row_12_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_language-circle.png",
          "row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_user-remove.png",
          "row_9_value_1": "Collab Tools",
          "updated_at": 1781873467362,
          "layout_id": "comparison-full-table-layout",
          "section_id": 1781873467362,
          "row_8_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_award.png",
          "row_9_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_share.png",
          "pk": "PAGE#1781873455444",
          "row_2_feature": "Security Watermarking",
          "row_9_value_2": "Limited (Beta)",
          "title": "Other Advantages",
          "row_4_value_2": "Basic Blocking",
          "row_4_value_1": "User Blocking",
          "row_3_feature": "Stream Protection",
          "row_5_feature": "Web3 / NFT Integration",
          "name": "OTHER ADVANTAGES",
          "row_6_value_1": "VIP Tools",
          "row_6_value_2": "Livestream Only",
          "column_1_label": "TOPFAN",
          "page_id": 1781873455444,
          "row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-tick.png",
          "row_9_feature": "Creator Collaborations",
          "section_heading": "Other {Powerful TopFan} Advantages",
          "row_2_value_1": "Watermarking",
          "row_2_value_2": "Not Available",
          "secondary_background_color": "#000000",
          "row_7_feature": "Hashtag Organization",
          "row_13_feature": "Referral Program",
          "row_12_feature": "Auto Translation",
          "row_13_value_2": "Not Available",
          "row_13_value_1": "Higher Rewards",
          "heading_font_size": "medium",
          "row_10_feature": "Brand Ads",
          "row_11_value_1": "Coming Soon",
          "theme_color": "#7c3aed",
          "row_11_value_2": "Not Available",
          "background_image": null,
          "post_text_color": "#ffffff",
          "row_8_value_2": "Not Available",
          "row_8_value_1": "Rewards Supported",
          "row_1_feature": "Rich analytics",
          "section_subheading": "Additional tools that support safety, analytics, automation, and advanced creator workflows.",
          "sk": "SECTION#1781873467362"
        },
        {
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "name": "SUMMARY",
          "summary_heading": "Summary",
          "page_id": 1781873455444,
          "card_b_heading": "Who is Patreon best suited for?",
          "secondary_background_color": "#f7f7f7",
          "created_at": 1781873469779,
          "summary_text": "Patreon is one of the most recognized names in creator monetization, but recognition comes with trade-offs. Your page lives on their platform, you don't own your fan data, and fees increase as you grow. TopFan gives you a fully branded site, your own URL, full audience ownership, and a broader toolkit including courses, experiences, merchandise, and loyalty tools — without giving up control to a third-party platform.",
          "heading_font_size": "medium",
          "card_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990768335_frame_2147226356.png",
          "card_a_body": "TopFan is built for creators who want to grow beyond exclusive content. Helps creators sell memberships, videos, courses, downloads, merchandise, experiences, and fan access from one platform. TopFan is best suited for creators and creator teams who want stronger fan ownership, deeper engagement, multiple revenue streams, and community-led growth.",
          "background_text_color": "#1b1b1b",
          "card_a_heading": "Who is TopFan best suited for?",
          "theme_color": "#7c3aed",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011728372_background_flare__1_.jpg",
          "updated_at": 1781873469779,
          "post_text_color": "#000000",
          "layout_id": "comparison-audience-summary-layout",
          "section_id": 1781873469779,
          "card_b_body": "Patreon is best suited for podcasters, writers, artists, and YouTubers who want a well-known membership platform with tiered subscriptions and recurring revenue. It works well for creators comfortable building on Patreon's domain under their brand. Creators who need a custom URL, full fan data ownership, course selling, or loyalty tools will find it limiting as they scale.",
          "pk": "PAGE#1781873455444",
          "card_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780922932705_group.png",
          "title": "SUMMARY",
          "sk": "SECTION#1781873469779"
        },
        {
          "button_text_color": "#ffffff",
          "testimonial_6_background_image": null,
          "background_color": "#d0e9ee",
          "testimonial_4_creator_type": "Professionals",
          "testimonial_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
          "testimonial_6_name": "The Predictors",
          "testimonial_2_user_name": "julia-kugel",
          "testimonial_6_creator_type": "Organizations",
          "testimonial_4_stars": "5",
          "testimonial_5_name": "Tulsa Bite",
          "testimonial_2_content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
          "testimonial_7_stars": "5",
          "testimonial_5_user_name": "tulsa_bite",
          "testimonial_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
          "testimonial_7_background_image": null,
          "testimonial_title": "Testimonials",
          "created_at": 1781873472392,
          "testimonial_4_background_image": null,
          "testimonial_5_stars": "5",
          "testimonial_1_user_name": "johnward",
          "background_text_color": "#000000",
          "testimonial_5_content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space.",
          "updated_at": 1781873472392,
          "testimonial_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
          "layout_id": "testimonial-layout",
          "section_id": 1781873472392,
          "testimonial_7_redirection_link": "https://www.markschlereth.fans/",
          "testimonial_1_stars": "5",
          "testimonial_4_user_name": "davidgold",
          "testimonial_2_redirection_link": "https://www.juliajulia.fans/",
          "pk": "PAGE#1781873455444",
          "testimonial_7_content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform.",
          "testimonial_5_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
          "title": "TESTIMONIALS",
          "testimonial_3_name": "Katrina Darling Friedman",
          "testimonial_7_user_name": "markschlereth",
          "testimonial_6_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
          "testimonial_5_creator_type": "Creator and Influencer",
          "testimonial_1_background_image": null,
          "testimonial_3_redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
          "name": "TESTIMONIALS",
          "testimonial_7_creator_type": "Athletes",
          "testimonial_3_user_name": "katrinadarlingfriedman",
          "testimonial_3_content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
          "page_id": 1781873455444,
          "testimonial_3_background_image": null,
          "section_heading": "More than {1,000} Creators Have Trusted Us Since We Started.",
          "testimonial_4_redirection_link": "https://www.goldweatherkingdom.com/",
          "testimonial_2_background_image": null,
          "testimonial_5_redirection_link": "https://www.topfan.com/tulsa_bite",
          "testimonial_1_content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
          "secondary_background_color": "#000000",
          "testimonial_2_stars": "5",
          "testimonial_2_name": "Julia Julia",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "johnward",
              "name": "John Ward",
              "redirection_link": "https://www.topfan.com/johnward",
              "stars": "5",
              "content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
              "creator_type": "Musicians",
              "user_name": "julia-kugel",
              "name": "Julia Julia",
              "redirection_link": "https://www.juliajulia.fans/",
              "stars": "5",
              "content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!"
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "katrinadarlingfriedman",
              "name": "Katrina Darling Friedman",
              "redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
              "stars": "5",
              "content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
              "creator_type": "Professionals",
              "user_name": "davidgold",
              "name": "David Gold",
              "redirection_link": "https://www.goldweatherkingdom.com/",
              "stars": "5",
              "content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
              "creator_type": "Creator and Influencer",
              "user_name": "tulsa_bite",
              "name": "Tulsa Bite",
              "redirection_link": "https://www.topfan.com/tulsa_bite",
              "stars": "5",
              "content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
              "creator_type": "Organizations",
              "user_name": "the-predictors",
              "name": "The Predictors",
              "redirection_link": "https://www.thepredictors.fans/",
              "stars": "5",
              "content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
              "creator_type": "Athletes",
              "user_name": "markschlereth",
              "name": "Mark Schlereth",
              "redirection_link": "https://www.markschlereth.fans/",
              "stars": "5",
              "content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform."
            }
          ],
          "testimonial_6_redirection_link": "https://www.thepredictors.fans/",
          "testimonial_6_user_name": "the-predictors",
          "testimonial_6_content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers.",
          "heading_font_size": "medium",
          "testimonial_1_redirection_link": "https://www.topfan.com/johnward",
          "testimonial_3_stars": "5",
          "testimonial_7_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
          "testimonial_1_name": "John Ward",
          "testimonial_4_content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.",
          "testimonial_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
          "theme_color": "#141515",
          "testimonial_5_background_image": null,
          "post_text_color": "#ffffff",
          "testimonial_6_stars": "5",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_4_name": "David Gold",
          "testimonial_1_creator_type": "Food, Fitness and Wellness",
          "testimonial_7_name": "Mark Schlereth",
          "testimonial_3_creator_type": "Food, Fitness and Wellness",
          "sk": "SECTION#1781873472392"
        }
      ]
    }
  },
  "topfan-vs-substack": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "seoKeywords": "topfan vs substack, substack alternative, newsletter monetization platform, creator platform beyond newsletters, substack comparison, fan engagement platform for writers",
      "post_text_color": "#ffffff",
      "created_at": 1781873382751,
      "background_color": "#000000",
      "status": "PUBLISHED",
      "sk": "PAGE#1781873382751",
      "url": "topfan-vs-substack",
      "pk": "MARKETINGPAGE",
      "competitor_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780989768080_frame_2147226357.png",
      "secondary_background_color": "#000000",
      "gsi1sk": "PAGE#1781873382751",
      "background_text_color": "#ffffff",
      "sequence_number": 3,
      "text_color": "#000000",
      "meta_title": "TopFan vs Substack: Which is the better platform?",
      "page_id": 1781873382751,
      "button_text_color": "#ffffff",
      "updated_at": 1781873382751,
      "gsi1pk": "topfan-vs-substack",
      "meta_description": "Compare TopFan and Substack on monetization, branding, and fan data — see why creators want more than newsletters and a 10% revenue cut.",
      "title": "Substack",
      "type": "MARKETING_COMPARISON",
      "sections": [
        {
          "subheading": "TopFan gives creators every tool to grow, engage, and earn — memberships, merch, courses, and live events — in one free, fully white-labeled platform. Substack caps you at a newsletter; TopFan doesn't.",
          "button_text_color": "#ffffff",
          "created_at": 1781873385165,
          "competitor_name": "Substack",
          "background_color": "#ffffff",
          "heading_font_size": "large",
          "background_text_color": "#000000",
          "theme_color": "#7c3aed",
          "name": "HERO PAGE",
          "platform_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780920210571_group.png",
          "background_image": null,
          "updated_at": 1781873385165,
          "page_id": 1781873382751,
          "post_text_color": "#000000",
          "layout_id": "comparison-hero-layout",
          "section_id": 1781873385165,
          "section_heading": "{TopFan vs Substack: Which is the better platform?}",
          "secondary_background_color": "#000000",
          "platform_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990709802_frame_2147226357.png",
          "pk": "PAGE#1781873382751",
          "title": "Hero Page",
          "sk": "SECTION#1781873385165"
        },
        {
          "subheading": "TopFans gives creators the tools to monetize, engage, grow, & manage their fan business.",
          "value_card_1_description": "Sell memberships, exclusive content, tips, paid DMs, merchandise, courses, and experiences from one platform.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "value_card_3_description": "Grow beyond social media with discovery tools, referrals, loyal fan rewards, and brand partnership opportunities.",
          "value_card_4_description": "Own your fan data, track content performance, manage access, and protect your content with built-in safety tools.",
          "name": "WHY CHOOSE TOPFAN",
          "page_id": 1781873382751,
          "value_card_2_title": "Deeper Fan Engagement",
          "section_heading": "{Why Choose TopFan?}",
          "value_card_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_message-chat-circle.png",
          "secondary_background_color": "#1f1f1e",
          "value_card_2_description": "Build stronger relationships through direct messages, polls, private communities, rewards, and personalized fan interactions.",
          "created_at": 1781873387547,
          "value_card_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-04.png",
          "heading_font_size": "medium",
          "value_card_4_title": "Full Control & Insights",
          "background_text_color": "#ffffff",
          "theme_color": "#5e00ff",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1780920467614_cb2078a3a11ac679ddb58d9cc8cf4c8bef941e9d__1_.png",
          "updated_at": 1781873387547,
          "post_text_color": "#ffffff",
          "layout_id": "comparison-value-grid-layout",
          "section_id": 1781873387547,
          "value_card_3_title": "Creator-Led Growth",
          "value_card_1_title": "More Ways to Earn",
          "value_card_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-03.png",
          "pk": "PAGE#1781873382751",
          "title": "WHY CHOOSE TOPFAN",
          "value_card_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_line-chart-up-03.png",
          "sk": "SECTION#1781873387547"
        },
        {
          "block_2_image_position": "left",
          "button_text_color": "#ffffff",
          "block_1_row_4_value_competitor": "Full Export",
          "background_color": "#ffffff",
          "block_4_row_1_feature": "Discovery Algorithm",
          "block_2_row_2_feature": "Tips on content & DMs",
          "block_4_row_1_value_competitor": "Not Available",
          "block_4_row_5_feature": "Loyalty Gamification",
          "block_3_row_1_value_topfan": "Media Selling",
          "block_3_row_2_value_topfan": "Audio Selling",
          "block_4_row_5_value_topfan": "Loyalty Tools",
          "block_4_row_4_value_topfan": "Supported",
          "block_2_row_2_value_topfan": "Tips Supported",
          "created_at": 1781873389997,
          "block_2_row_3_value_topfan": "Locked DMs",
          "block_1_row_3_value_topfan": "Custom URL",
          "block_3_row_3_feature": "Online Courses",
          "block_1_row_4_value_topfan": "Full Ownership",
          "block_1_row_2_value_competitor": "No Fan Fee",
          "block_1_heading": "Creator Setup & Control",
          "block_3_row_5_value_topfan": "Experience Selling",
          "layout_id": "comparison-feature-section-layout",
          "block_3_row_1_value_competitor": "Limited",
          "block_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__1_.png",
          "block_1_row_4_feature": "Fan Data Ownership",
          "subheading": "A full-stack online community platform designed for flexibility and scalability, empowering organizations to build, manage, and engage communities with ease.",
          "block_2_row_2_value_competitor": "Limited Support",
          "block_4_row_4_feature": "Polls",
          "block_1_row_5_feature": "Publishing Scheduler",
          "block_2_row_1_feature": "Membership Tiers",
          "name": "COMMUNITY BUILDER",
          "page_id": 1781873382751,
          "block_1_image_position": "right",
          "section_heading": "{TopFan} is more than a Community Builder",
          "block_1_row_1_value_topfan": "5-15% plus standard 3rd party credit card fees",
          "block_2_row_5_feature": "Prize Giveaway",
          "block_4_row_1_value_topfan": "Built-in Discovery",
          "competitor_column_label": "Substack",
          "block_3_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_document-download.png",
          "block_2_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like.png",
          "block_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_content.png",
          "block_3_row_2_value_competitor": "Audio Selling",
          "block_4_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like__1_.png",
          "block_4_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_messages-2.png",
          "heading_font_size": "medium",
          "block_4_row_5_value_competitor": "Not Available",
          "block_3_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_musicnote.png",
          "block_1_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_receipt-2.png",
          "block_1_row_1_feature": "Creator Platform Fee",
          "theme_color": "#000000",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011690291_background_flare__1_.jpg",
          "post_text_color": "#000000",
          "block_2_heading": "Monetization & Selling",
          "block_3_row_4_feature": "Downloadable Content",
          "block_3_row_5_value_competitor": "Not Available",
          "block_2_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_star.png",
          "block_1_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_key.png",
          "block_4_row_2_value_competitor": "Limited",
          "block_4_row_3_feature": "Private Chat Rooms",
          "block_2_row_4_feature": "Shopify Supported",
          "block_1_row_3_value_competitor": "Limited ($50 fee)",
          "block_2_row_5_value_competitor": "Not Available",
          "topfan_column_label": "TopFan",
          "block_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__2_.png",
          "block_2_row_1_value_topfan": "Supported",
          "block_3_row_1_feature": "Videos & Galleries",
          "block_3_row_4_value_topfan": "Downloadable Selling",
          "block_4_row_2_value_topfan": "Supported",
          "block_1_row_2_value_topfan": "No Fan Fee",
          "block_4_row_3_value_topfan": "Supported",
          "block_3_row_3_value_topfan": "Course Selling",
          "block_4_row_4_value_competitor": "Supported",
          "block_4_description": "Build stronger fan relationships through interaction, discovery, and loyalty tools.",
          "block_2_row_4_value_topfan": "Supported",
          "background_text_color": "#000000",
          "block_3_description": "Sell different content formats from one creator storefront.",
          "block_1_description": "Set up, customize, and manage your creator presence with more ownership.",
          "block_2_row_5_value_topfan": "Giveaway Tools",
          "block_1_row_5_value_topfan": "Supported",
          "block_2_description": "Give creators more ways to earn through content, access, and fan purchases.",
          "updated_at": 1781873389997,
          "block_2_row_3_value_competitor": "Not Available",
          "block_1_row_2_feature": "Fan Platform Fee",
          "section_id": 1781873389997,
          "block_3_image_position": "right",
          "block_3_heading": "Content Commerce",
          "block_1_row_5_value_competitor": "Supported",
          "block_4_image_position": "left",
          "pk": "PAGE#1781873382751",
          "block_3_row_5_feature": "Experiences",
          "title": "COMMUNITY BUILDER",
          "block_4_row_2_feature": "Targeted Outreach",
          "block_3_row_4_value_competitor": "Limited",
          "block_3_row_3_value_competitor": "Not Available",
          "block_2_row_3_feature": "Paid / Locked DMs",
          "secondary_background_color": "#000000",
          "block_2_row_1_value_competitor": "Limited Tiers",
          "block_3_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_teacher.png",
          "block_2_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_sms-star.png",
          "block_1_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_money.png",
          "block_2_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_crown.png",
          "block_4_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_shield-tick.png",
          "block_2_row_4_value_competitor": "Not Supported",
          "block_4_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_code-circle.png",
          "block_3_row_2_feature": "Audio & Music",
          "block_3_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gallery.png",
          "block_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__3_.png",
          "block_1_row_3_feature": "Custom Website URL",
          "block_4_row_3_value_competitor": "Supported",
          "block_1_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_send-2.png",
          "block_1_row_1_value_competitor": "13-16% plus plus standard 3rd party credit card fees",
          "block_1_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_global.png",
          "block_2_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gift.png",
          "block_4_heading": "Fan Engagement & Growth",
          "block_4_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_coin.png",
          "block_3_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_flash.png",
          "sk": "SECTION#1781873389997"
        },
        {
          "subheading": "See how TopFans helps creators move beyond locked content with better control, wider monetization, and stronger fan-business tools.",
          "button_text_color": "#ffffff",
          "background_color": "#ffffff",
          "key_win_1_description": "TopFan is completely free for creators and gives you a fully white-labeled website and app from day one — Substack's $50 custom domain is subdomain-only and forfeits its own discovery network the moment you connect it.",
          "key_win_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__2_.png",
          "key_win_5_title": "Engage Beyond Content Drops",
          "key_win_6_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__5_.png",
          "name": "WHERE TOPFAN WINS",
          "page_id": 1781873382751,
          "key_win_6_description": "TopFan includes referral tools, real ticketing, and brand collaboration features for every creator free from day one, while Substack's sponsorship program is capped to creators with 100+ paid subscribers and offers no ticketing at all.",
          "key_win_5_description": "TopFan pairs built-in gamification, loyalty rewards, and a discovery algorithm in one place, while Substack's strong discovery network has no rewards system — and disappears entirely once you connect your own domain.",
          "key_win_4_title": "Own the Audience Relationship",
          "section_heading": "Where TopFan wins {over Substack}",
          "key_win_2_title": "Keep More From Every Sale",
          "key_win_3_description": "TopFan gives you subscriptions, merch, tickets, and ads in one connected platform, while Substack has no built-in storefront — selling merch means linking out to Shopify or another store entirely.",
          "secondary_background_color": "#0f172a",
          "key_win_2_description": "Keep up to 95% of every merch and ticket sale and 85% on subscriptions with TopFan, while Substack's 10% platform fee plus processing and billing fees pushes the real cost to 13–16% of every dollar a paid subscriber sends you.",
          "key_win_4_description": "TopFan gives creators full ownership of fans and data from day one, while Substack only lets writers manually export an email list rather than truly own the relationship inside the platform.",
          "key_win_6_title": "Built for Long-Term Growth",
          "created_at": 1781873392458,
          "heading_font_size": "medium",
          "background_text_color": "#1e293b",
          "key_win_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__3_.png",
          "theme_color": "#7c3aed",
          "key_win_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956730_featured_icon__1_.png",
          "background_image": null,
          "key_win_1_title": "More Creator Control",
          "updated_at": 1781873392458,
          "key_win_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon.png",
          "post_text_color": "#000000",
          "layout_id": "comparison-key-wins-layout",
          "section_id": 1781873392458,
          "pk": "PAGE#1781873382751",
          "key_win_3_title": "Turn Fans Into Buyers",
          "title": "WHERE TOPFAN WINS",
          "key_win_5_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__4_.png",
          "sk": "SECTION#1781873392458"
        },
        {
          "button_text_color": "#ffffff",
          "row_5_value_2": "Not Available",
          "row_4_feature": "Block Users",
          "background_color": "#000000",
          "row_5_value_1": "Web3 Support",
          "row_7_value_2": "Not Available",
          "row_6_feature": "VIP access & ticketing",
          "row_7_value_1": "Hashtag Search",
          "row_1_value_1": "Advanced Insights",
          "row_1_value_2": "Not Available",
          "row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_status-up.png",
          "row_3_value_1": "Available",
          "row_8_feature": "Fan Rewards",
          "row_3_value_2": "Not Available",
          "row_12_value_1": "243 Languages",
          "row_10_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_tag.png",
          "row_11_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_color-swatch.png",
          "created_at": 1781873395042,
          "row_11_feature": "Designer Access",
          "row_7_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_hashtag.png",
          "row_12_value_2": "Not Available",
          "row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_fi_6699366.png",
          "row_10_value_2": "Not Available",
          "column_2_label": "Substack",
          "row_6_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_ticket-star.png",
          "background_text_color": "#ffffff",
          "row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-security.png",
          "row_10_value_1": "Available",
          "row_13_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_convertshape-2.png",
          "row_12_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_language-circle.png",
          "row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_user-remove.png",
          "row_9_value_1": "Collab Tools",
          "updated_at": 1781873395042,
          "layout_id": "comparison-full-table-layout",
          "section_id": 1781873395042,
          "row_8_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_award.png",
          "row_9_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_share.png",
          "pk": "PAGE#1781873382751",
          "row_2_feature": "Security Watermarking",
          "row_9_value_2": "Not Available",
          "title": "Other Advantages",
          "row_4_value_2": "Not Available",
          "row_4_value_1": "User Blocking",
          "row_3_feature": "Stream Protection",
          "row_5_feature": "Web3 / NFT Integration",
          "name": "OTHER ADVANTAGES",
          "row_6_value_1": "VIP Tools",
          "row_6_value_2": "Not Available",
          "column_1_label": "TOPFAN",
          "page_id": 1781873382751,
          "row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-tick.png",
          "row_9_feature": "Creator Collaborations",
          "section_heading": "Other {Powerful TopFan} Advantages",
          "row_2_value_1": "Watermarking",
          "row_2_value_2": "Not Available",
          "secondary_background_color": "#000000",
          "row_7_feature": "Hashtag Organization",
          "row_13_feature": "Referral Program",
          "row_12_feature": "Auto Translation",
          "row_13_value_2": "Not Available",
          "row_13_value_1": "Higher Rewards",
          "heading_font_size": "medium",
          "row_10_feature": "Brand Ads",
          "row_11_value_1": "Coming Soon",
          "theme_color": "#7c3aed",
          "row_11_value_2": "Not Available",
          "post_text_color": "#ffffff",
          "row_8_value_2": "Not Available",
          "row_8_value_1": "Rewards Supported",
          "row_1_feature": "Rich analytics",
          "section_subheading": "Additional tools that support safety, analytics, automation, and advanced creator workflows.",
          "sk": "SECTION#1781873395042"
        },
        {
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "name": "SUMMARY",
          "summary_heading": "Summary",
          "page_id": 1781873382751,
          "card_b_heading": "Who is Substack best suited for?",
          "secondary_background_color": "#f7f7f7",
          "created_at": 1781873397401,
          "summary_text": "While Substack focuses mainly on email newsletters and a single paid subscription tier, TopFan is designed as a broader creator growth platform. TopFan gives creators more ways to earn, engage, and scale through memberships, content commerce, merchandise, courses, experiences, fan ownership, loyalty tools, and community-led growth.",
          "heading_font_size": "medium",
          "card_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780990727484_frame_2147226357.png",
          "card_a_body": "TopFan is built for creators who want to grow beyond exclusive content. Helps creators sell memberships, videos, courses, downloads, merchandise, experiences, and fan access from one platform. TopFan is best suited for creators and creator teams who want stronger fan ownership, deeper engagement, multiple revenue streams, and community-led growth.",
          "background_text_color": "#1b1b1b",
          "card_a_heading": "Who is TopFan best suited for?",
          "theme_color": "#7c3aed",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011673075_background_flare__1_.jpg",
          "updated_at": 1781873397401,
          "post_text_color": "#000000",
          "layout_id": "comparison-audience-summary-layout",
          "section_id": 1781873397401,
          "card_b_body": "Substack is built for writers running an email-first publication — people whose business really is the newsletter, with Substack's reader network as the main growth engine. However, creators wanting to sell merch, host ticketed events, run a real rewards program, or build a presence beyond a subdomain may need a more complete platform experience.",
          "pk": "PAGE#1781873382751",
          "card_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780922932705_group.png",
          "title": "SUMMARY",
          "sk": "SECTION#1781873397401"
        },
        {
          "button_text_color": "#ffffff",
          "testimonial_6_background_image": null,
          "background_color": "#d0e9ee",
          "testimonial_4_creator_type": "Professionals",
          "testimonial_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
          "testimonial_6_name": "The Predictors",
          "testimonial_2_user_name": "julia-kugel",
          "testimonial_6_creator_type": "Organizations",
          "testimonial_4_stars": "5",
          "testimonial_5_name": "Tulsa Bite",
          "testimonial_2_content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
          "testimonial_7_stars": "5",
          "testimonial_5_user_name": "tulsa_bite",
          "testimonial_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
          "testimonial_7_background_image": null,
          "testimonial_title": "Testimonials",
          "created_at": 1781873400315,
          "testimonial_4_background_image": null,
          "testimonial_5_stars": "5",
          "testimonial_1_user_name": "johnward",
          "background_text_color": "#000000",
          "testimonial_5_content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space.",
          "updated_at": 1781873400315,
          "testimonial_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
          "layout_id": "testimonial-layout",
          "section_id": 1781873400315,
          "testimonial_7_redirection_link": "https://www.markschlereth.fans/",
          "testimonial_1_stars": "5",
          "testimonial_4_user_name": "davidgold",
          "testimonial_2_redirection_link": "https://www.juliajulia.fans/",
          "pk": "PAGE#1781873382751",
          "testimonial_7_content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform.",
          "testimonial_5_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
          "title": "TESTIMONIALS",
          "testimonial_3_name": "Katrina Darling Friedman",
          "testimonial_7_user_name": "markschlereth",
          "testimonial_6_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
          "testimonial_5_creator_type": "Creator and Influencer",
          "testimonial_1_background_image": null,
          "testimonial_3_redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
          "name": "TESTIMONIALS",
          "testimonial_7_creator_type": "Athletes",
          "testimonial_3_user_name": "katrinadarlingfriedman",
          "testimonial_3_content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
          "page_id": 1781873382751,
          "testimonial_3_background_image": null,
          "section_heading": "More than {1,000} Creators Have Trusted Us Since We Started.",
          "testimonial_4_redirection_link": "https://www.goldweatherkingdom.com/",
          "testimonial_2_background_image": null,
          "testimonial_5_redirection_link": "https://www.topfan.com/tulsa_bite",
          "testimonial_1_content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
          "secondary_background_color": "#000000",
          "testimonial_2_stars": "5",
          "testimonial_2_name": "Julia Julia",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "johnward",
              "name": "John Ward",
              "redirection_link": "https://www.topfan.com/johnward",
              "stars": "5",
              "content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
              "creator_type": "Musicians",
              "user_name": "julia-kugel",
              "name": "Julia Julia",
              "redirection_link": "https://www.juliajulia.fans/",
              "stars": "5",
              "content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!"
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "katrinadarlingfriedman",
              "name": "Katrina Darling Friedman",
              "redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
              "stars": "5",
              "content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
              "creator_type": "Professionals",
              "user_name": "davidgold",
              "name": "David Gold",
              "redirection_link": "https://www.goldweatherkingdom.com/",
              "stars": "5",
              "content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
              "creator_type": "Creator and Influencer",
              "user_name": "tulsa_bite",
              "name": "Tulsa Bite",
              "redirection_link": "https://www.topfan.com/tulsa_bite",
              "stars": "5",
              "content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
              "creator_type": "Organizations",
              "user_name": "the-predictors",
              "name": "The Predictors",
              "redirection_link": "https://www.thepredictors.fans/",
              "stars": "5",
              "content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
              "creator_type": "Athletes",
              "user_name": "markschlereth",
              "name": "Mark Schlereth",
              "redirection_link": "https://www.markschlereth.fans/",
              "stars": "5",
              "content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform."
            }
          ],
          "testimonial_6_redirection_link": "https://www.thepredictors.fans/",
          "testimonial_6_user_name": "the-predictors",
          "testimonial_6_content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers.",
          "heading_font_size": "medium",
          "testimonial_1_redirection_link": "https://www.topfan.com/johnward",
          "testimonial_3_stars": "5",
          "testimonial_7_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
          "testimonial_1_name": "John Ward",
          "testimonial_4_content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.",
          "testimonial_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
          "theme_color": "#141515",
          "testimonial_5_background_image": null,
          "post_text_color": "#ffffff",
          "testimonial_6_stars": "5",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_4_name": "David Gold",
          "testimonial_1_creator_type": "Food, Fitness and Wellness",
          "testimonial_7_name": "Mark Schlereth",
          "testimonial_3_creator_type": "Food, Fitness and Wellness",
          "sk": "SECTION#1781873400315"
        }
      ]
    }
  },
  "topfan-vs-uscreen": {
    "status": true,
    "statusCode": 200,
    "message": "Success",
    "data": {
      "created_at": 1781872732963,
      "url": "topfan-vs-uscreen",
      "background_text_color": "#ffffff",
      "sequence_number": 8,
      "background_color": "#000000",
      "sk": "PAGE#1781872732963",
      "type": "MARKETING_COMPARISON",
      "button_text_color": "#ffffff",
      "meta_title": "TopFan vs Uscreen: Which Is the Better Platform in 2026?",
      "secondary_background_color": "#000000",
      "seoKeywords": "topfan vs passes, passes app alternative, creator monetization platform, own branded fan platform, passes pricing comparison, creator accelerator alternative",
      "pk": "MARKETINGPAGE",
      "title": "Uscreen",
      "text_color": "#000000",
      "page_id": 1781872732963,
      "gsi1pk": "topfan-vs-uscreen",
      "status": "PUBLISHED",
      "updated_at": 1781872732963,
      "gsi1sk": "PAGE#1781872732963",
      "competitor_logo": "https://cdn-www7.topfans.dev/TopFans/Home1781850947317_uscreen.png",
      "post_text_color": "#ffffff",
      "meta_description": "Compare TopFan and Passes on fees, branding, and fan data ownership.",
      "sections": [
        {
          "subheading": "A creator-first platform helping you grow, engage, and earn through subscriptions, content, and live experiences — all on your own branded site and app, not Passes'.",
          "button_text_color": "#ffffff",
          "created_at": 1781872735386,
          "competitor_name": "Uscreen",
          "background_color": "#ffffff",
          "heading_font_size": "large",
          "background_text_color": "#000000",
          "theme_color": "#7c3aed",
          "name": "HERO PAGE",
          "platform_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780920210571_group.png",
          "background_image": null,
          "updated_at": 1781872735386,
          "page_id": 1781872732963,
          "post_text_color": "#000000",
          "layout_id": "comparison-hero-layout",
          "section_id": 1781872735386,
          "section_heading": "{TopFan vs Uscreen: Which is the better platform?}",
          "secondary_background_color": "#000000",
          "platform_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1781850877601_uscreen.png",
          "pk": "PAGE#1781872732963",
          "title": "Hero Page",
          "sk": "SECTION#1781872735386"
        },
        {
          "subheading": "TopFans gives creators the tools to monetize, engage, grow, & manage their fan business.",
          "value_card_1_description": "Sell memberships, exclusive content, tips, paid DMs, merchandise, courses, and experiences from one platform.",
          "button_text_color": "#ffffff",
          "background_color": "#000000",
          "value_card_3_description": "Grow beyond social media with discovery tools, referrals, loyal fan rewards, and brand partnership opportunities.",
          "value_card_4_description": "Own your fan data, track content performance, manage access, and protect your content with built-in safety tools.",
          "name": "WHY CHOOSE TOPFAN",
          "page_id": 1781872732963,
          "value_card_2_title": "Deeper Fan Engagement",
          "section_heading": "{Why Choose TopFan?}",
          "value_card_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_message-chat-circle.png",
          "secondary_background_color": "#1f1f1e",
          "value_card_2_description": "Build stronger relationships through direct messages, polls, private communities, rewards, and personalized fan interactions.",
          "created_at": 1781872737737,
          "value_card_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-04.png",
          "heading_font_size": "medium",
          "value_card_4_title": "Full Control & Insights",
          "background_text_color": "#ffffff",
          "theme_color": "#5e00ff",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1780920467614_cb2078a3a11ac679ddb58d9cc8cf4c8bef941e9d__1_.png",
          "updated_at": 1781872737737,
          "post_text_color": "#ffffff",
          "layout_id": "comparison-value-grid-layout",
          "section_id": 1781872737737,
          "value_card_3_title": "Creator-Led Growth",
          "value_card_1_title": "More Ways to Earn",
          "value_card_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_award-03.png",
          "pk": "PAGE#1781872732963",
          "title": "WHY CHOOSE TOPFAN",
          "value_card_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780920467615_line-chart-up-03.png",
          "sk": "SECTION#1781872737737"
        },
        {
          "block_2_image_position": "left",
          "button_text_color": "#ffffff",
          "block_1_row_4_value_competitor": "Limited Control",
          "background_color": "#ffffff",
          "block_4_row_1_feature": "Discovery Algorithm",
          "block_2_row_2_feature": "Tips on content & DMs",
          "block_4_row_1_value_competitor": "Built-in Discovery",
          "block_4_row_5_feature": "Loyalty Gamification",
          "block_3_row_1_value_topfan": "Media Selling",
          "block_3_row_2_value_topfan": "Audio Selling",
          "block_4_row_5_value_topfan": "Loyalty Tools",
          "block_4_row_4_value_topfan": "Supported",
          "block_2_row_2_value_topfan": "Tips Supported",
          "created_at": 1781872740170,
          "block_2_row_3_value_topfan": "Locked DMs",
          "block_1_row_3_value_topfan": "Custom URL",
          "block_3_row_3_feature": "Online Courses",
          "block_1_row_4_value_topfan": "Full Ownership",
          "block_1_row_2_value_competitor": "No Fan Fee",
          "block_1_heading": "Creator Setup & Control",
          "block_3_row_5_value_topfan": "Experiences Selling",
          "layout_id": "comparison-feature-section-layout",
          "block_3_row_1_value_competitor": "Media Selling",
          "block_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__1_.png",
          "block_1_row_4_feature": "Fan Data Ownership",
          "subheading": "A full-stack online community platform designed for flexibility and scalability, empowering organizations to build, manage, and engage communities with ease.",
          "block_2_row_2_value_competitor": "Tips Supported",
          "block_4_row_4_feature": "Polls",
          "block_1_row_5_feature": "Publishing Scheduler",
          "block_2_row_1_feature": "Membership Tiers",
          "name": "COMMUNITY BUILDER",
          "page_id": 1781872732963,
          "block_1_image_position": "right",
          "section_heading": "{TopFan} is more than a Community Builder",
          "block_1_row_1_value_topfan": "5-15% plus standard 3rd party credit card fees",
          "block_2_row_5_feature": "Prize Giveaway",
          "block_4_row_1_value_topfan": "Built-in Discovery",
          "competitor_column_label": "Uscreen",
          "block_3_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_document-download.png",
          "block_2_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like.png",
          "block_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_content.png",
          "block_3_row_2_value_competitor": "Audio Selling",
          "block_4_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_like__1_.png",
          "block_4_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_messages-2.png",
          "heading_font_size": "medium",
          "block_4_row_5_value_competitor": "Not Available",
          "block_3_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_musicnote.png",
          "block_1_row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_receipt-2.png",
          "block_1_row_1_feature": "Creator Platform Fee",
          "theme_color": "#000000",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011654314_background_flare__1_.jpg",
          "post_text_color": "#000000",
          "block_2_heading": "Monetization & Selling",
          "block_3_row_4_feature": "Downloadable Content",
          "block_3_row_5_value_competitor": "Experiences",
          "block_2_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_star.png",
          "block_1_row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_key.png",
          "block_4_row_2_value_competitor": "Not available",
          "block_4_row_3_feature": "Private Chat Rooms",
          "block_2_row_4_feature": "Shopify Supported",
          "block_1_row_3_value_competitor": "Not Available",
          "block_2_row_5_value_competitor": "Not Available",
          "topfan_column_label": "TopFan",
          "block_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__2_.png",
          "block_2_row_1_value_topfan": "Supported",
          "block_3_row_1_feature": "Videos & Galleries",
          "block_3_row_4_value_topfan": "Downloadable Selling",
          "block_4_row_2_value_topfan": "Supported",
          "block_1_row_2_value_topfan": "No Fan Fee",
          "block_4_row_3_value_topfan": "Supported",
          "block_3_row_3_value_topfan": "Course Selling",
          "block_4_row_4_value_competitor": "Not Available",
          "block_4_description": "Build stronger fan relationships through interaction, discovery, and loyalty tools.",
          "block_2_row_4_value_topfan": "Supported",
          "background_text_color": "#000000",
          "block_3_description": "Sell different content formats from one creator storefront.",
          "block_1_description": "Set up, customize, and manage your creator presence with more ownership.",
          "block_2_row_5_value_topfan": "Giveaway Tools",
          "block_1_row_5_value_topfan": "Supported",
          "block_2_description": "Give creators more ways to earn through content, access, and fan purchases.",
          "updated_at": 1781872740170,
          "block_2_row_3_value_competitor": "Locked DMs",
          "block_1_row_2_feature": "Fan Platform Fee",
          "section_id": 1781872740170,
          "block_3_image_position": "right",
          "block_3_heading": "Content Commerce",
          "block_1_row_5_value_competitor": "Supported",
          "block_4_image_position": "left",
          "pk": "PAGE#1781872732963",
          "block_3_row_5_feature": "Experiences",
          "title": "COMMUNITY BUILDER",
          "block_4_row_2_feature": "Targeted Outreach",
          "block_3_row_4_value_competitor": "Downloadable Selling",
          "block_3_row_3_value_competitor": "Course Selling",
          "block_2_row_3_feature": "Paid / Locked DMs",
          "secondary_background_color": "#000000",
          "block_2_row_1_value_competitor": "Supported",
          "block_3_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_teacher.png",
          "block_2_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_sms-star.png",
          "block_1_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_money.png",
          "block_2_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_crown.png",
          "block_4_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_shield-tick.png",
          "block_2_row_4_value_competitor": "Supported",
          "block_4_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_code-circle.png",
          "block_3_row_2_feature": "Audio & Music",
          "block_3_row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gallery.png",
          "block_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_content__3_.png",
          "block_1_row_3_feature": "Custom Website URL",
          "block_4_row_3_value_competitor": "Supported",
          "block_1_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_send-2.png",
          "block_1_row_1_value_competitor": "10% fee plus standard 3rd party credit card fees",
          "block_1_row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716948_global.png",
          "block_2_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_gift.png",
          "block_4_heading": "Fan Engagement & Growth",
          "block_4_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_coin.png",
          "block_3_row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921716949_flash.png",
          "sk": "SECTION#1781872740170"
        },
        {
          "subheading": "See how TopFans helps creators move beyond locked content with better control, wider monetization, and stronger fan-business tools.",
          "button_text_color": "#ffffff",
          "background_color": "#ffffff",
          "key_win_1_description": "TopFans gives creators custom URLs, fan data ownership, and stronger control over how they manage their fan business.",
          "key_win_3_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__2_.png",
          "key_win_5_title": "Engage Beyond Content Drops",
          "key_win_6_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__5_.png",
          "name": "WHERE TOPFAN WINS",
          "page_id": 1781872732963,
          "key_win_6_description": "TopFans supports creator growth through discovery, referrals, loyalty rewards, VIP access, brand opportunities, and advanced fan insights.",
          "key_win_5_description": "TopFans helps creators build stronger fan relationships through polls, private rooms, rewards, targeted messages, and paid interactions.",
          "key_win_4_title": "Own the Audience Relationship",
          "section_heading": "Where TopFan wins {over Uscreen}",
          "key_win_2_title": "Keep More From Every Sale",
          "key_win_3_description": "TopFans lets creators sell more than posts — including merchandise, courses, downloads, audio, experiences, and premium content collections.",
          "secondary_background_color": "#0f172a",
          "key_win_2_description": "TopFans offers a more creator-friendly fee structure, helping creators retain more value from memberships, paid content, and fan transactions.",
          "key_win_4_description": "With fan data ownership, segmentation, and export options, TopFans gives creators more control over their audience beyond the platform.",
          "key_win_6_title": "Built for Long-Term Growth",
          "created_at": 1781872742648,
          "heading_font_size": "medium",
          "background_text_color": "#1e293b",
          "key_win_4_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__3_.png",
          "theme_color": "#7c3aed",
          "key_win_1_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956730_featured_icon__1_.png",
          "background_image": null,
          "key_win_1_title": "More Creator Control",
          "updated_at": 1781872742648,
          "key_win_2_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon.png",
          "post_text_color": "#000000",
          "layout_id": "comparison-key-wins-layout",
          "section_id": 1781872742648,
          "pk": "PAGE#1781872732963",
          "key_win_3_title": "Turn Fans Into Buyers",
          "title": "WHERE TOPFAN WINS",
          "key_win_5_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780921956731_featured_icon__4_.png",
          "sk": "SECTION#1781872742648"
        },
        {
          "button_text_color": "#ffffff",
          "row_5_value_2": "Not Available",
          "row_4_feature": "Block Users",
          "background_color": "#000000",
          "row_5_value_1": "Web3 Support",
          "row_7_value_2": "Not Available",
          "row_6_feature": "VIP access & ticketing",
          "row_7_value_1": "Hashtag Search",
          "row_1_value_1": "Advanced Insights",
          "row_1_value_2": "Basic Analytics",
          "row_1_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_status-up.png",
          "row_3_value_1": "Available",
          "row_8_feature": "Fan Rewards",
          "row_3_value_2": "Available",
          "row_12_value_1": "243 Languages",
          "row_10_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_tag.png",
          "row_11_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_color-swatch.png",
          "created_at": 1781872745024,
          "row_11_feature": "Designer Access",
          "row_7_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_hashtag.png",
          "row_12_value_2": "Not Available",
          "row_5_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_fi_6699366.png",
          "row_10_value_2": "Not Available",
          "column_2_label": "Uscreen",
          "row_6_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_ticket-star.png",
          "background_text_color": "#ffffff",
          "row_3_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-security.png",
          "row_10_value_1": "Available",
          "row_13_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_convertshape-2.png",
          "row_12_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_language-circle.png",
          "row_4_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_user-remove.png",
          "row_9_value_1": "Collab Tools",
          "updated_at": 1781872745024,
          "layout_id": "comparison-full-table-layout",
          "section_id": 1781872745024,
          "row_8_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_award.png",
          "row_9_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_share.png",
          "pk": "PAGE#1781872732963",
          "row_2_feature": "Security Watermarking",
          "row_9_value_2": "Not Available",
          "title": "Other Advantages",
          "row_4_value_2": "User Blocking",
          "row_4_value_1": "User Blocking",
          "row_3_feature": "Stream Protection",
          "row_5_feature": "Web3 / NFT Integration",
          "name": "OTHER ADVANTAGES",
          "row_6_value_1": "VIP Tools",
          "row_6_value_2": "Not Available",
          "column_1_label": "TOPFAN",
          "page_id": 1781872732963,
          "row_2_feature_icon": "https://cdn-www7.topfans.dev/TopFans/Home1780922768472_shield-tick.png",
          "row_9_feature": "Creator Collaborations",
          "section_heading": "Other {Powerful TopFan} Advantages",
          "row_2_value_1": "Watermarking",
          "row_2_value_2": "Watermarking",
          "secondary_background_color": "#000000",
          "row_7_feature": "Hashtag Organization",
          "row_13_feature": "Referral Program",
          "row_12_feature": "Auto Translation",
          "row_13_value_2": "Not Available",
          "row_13_value_1": "Higher Rewards",
          "heading_font_size": "medium",
          "row_10_feature": "Brand Ads",
          "row_11_value_1": "Coming Soon",
          "theme_color": "#7c3aed",
          "row_11_value_2": "Not Available",
          "background_image": null,
          "post_text_color": "#ffffff",
          "row_8_value_2": "Not Available",
          "row_8_value_1": "Rewards Supported",
          "row_1_feature": "Rich analytics",
          "section_subheading": "Additional tools that support safety, analytics, automation, and advanced creator workflows.",
          "sk": "SECTION#1781872745024"
        },
        {
          "button_text_color": "#000000",
          "background_color": "#ffffff",
          "name": "SUMMARY",
          "summary_heading": "Summary",
          "page_id": 1781872732963,
          "card_b_heading": "Who is Uscreen best suited for?",
          "secondary_background_color": "#f7f7f7",
          "created_at": 1781872747413,
          "summary_text": "Uscreen offers more monetization flexibility than many creator platforms, with a 10% fee, anti-screenshot DRM, and digital product sales built in. But it still operates as a closed platform — your audience lives on Passes' infrastructure, under their domain, and you don't own your fan data. \n\nTopFan is built around the opposite model: your own branded site, your own URL, full fan data ownership, and a broader toolkit that includes courses, experiences, loyalty tools, and community-led growth — without giving up control to a third-party platform.",
          "heading_font_size": "medium",
          "card_b_logo": "https://cdn-www7.topfans.dev/TopFans/Home1781850929672_uscreen.png",
          "card_a_body": "TopFan is built for creators who want to grow beyond exclusive content. Helps creators sell memberships, videos, courses, downloads, merchandise, experiences, and fan access from one platform. TopFan is best suited for creators and creator teams who want stronger fan ownership, deeper engagement, multiple revenue streams, and community-led growth.",
          "background_text_color": "#1b1b1b",
          "card_a_heading": "Who is TopFan best suited for?",
          "theme_color": "#7c3aed",
          "background_image": "https://cdn-www7.topfans.dev/TopFans/Home1781011640635_background_flare__1_.jpg",
          "updated_at": 1781872747413,
          "post_text_color": "#000000",
          "layout_id": "comparison-audience-summary-layout",
          "section_id": 1781872747413,
          "card_b_body": "Uscreen is best suited for established creators who want a monetization-focused platform with subscriptions, paid DMs, and digital product sales. It works well for influencers with an existing audience who want multiple revenue streams and strong content protection. However, creators who need a custom-branded destination, full fan data ownership, course-building tools, loyalty gamification, or community-led growth features will find Passes falls short of a complete creator business platform.",
          "pk": "PAGE#1781872732963",
          "card_a_logo": "https://cdn-www7.topfans.dev/TopFans/Home1780922932705_group.png",
          "title": "SUMMARY",
          "sk": "SECTION#1781872747413"
        },
        {
          "button_text_color": "#ffffff",
          "testimonial_6_background_image": null,
          "background_color": "#d0e9ee",
          "testimonial_4_creator_type": "Professionals",
          "testimonial_4_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
          "testimonial_6_name": "The Predictors",
          "testimonial_2_user_name": "julia-kugel",
          "testimonial_6_creator_type": "Organizations",
          "testimonial_4_stars": "5",
          "testimonial_5_name": "Tulsa Bite",
          "testimonial_2_content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
          "testimonial_7_stars": "5",
          "testimonial_5_user_name": "tulsa_bite",
          "testimonial_1_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
          "testimonial_7_background_image": null,
          "testimonial_title": "Testimonials",
          "created_at": 1781872749809,
          "testimonial_4_background_image": null,
          "testimonial_5_stars": "5",
          "testimonial_1_user_name": "johnward",
          "background_text_color": "#000000",
          "testimonial_5_content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space.",
          "updated_at": 1781872749809,
          "testimonial_2_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
          "layout_id": "testimonial-layout",
          "section_id": 1781872749809,
          "testimonial_7_redirection_link": "https://www.markschlereth.fans/",
          "testimonial_1_stars": "5",
          "testimonial_4_user_name": "davidgold",
          "testimonial_2_redirection_link": "https://www.juliajulia.fans/",
          "pk": "PAGE#1781872732963",
          "testimonial_7_content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform.",
          "testimonial_5_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
          "title": "TESTIMONIALS",
          "testimonial_3_name": "Katrina Darling Friedman",
          "testimonial_7_user_name": "markschlereth",
          "testimonial_6_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
          "testimonial_5_creator_type": "Creator and Influencer",
          "testimonial_1_background_image": null,
          "testimonial_3_redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
          "name": "TESTIMONIALS",
          "testimonial_7_creator_type": "Athletes",
          "testimonial_3_user_name": "katrinadarlingfriedman",
          "testimonial_3_content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
          "page_id": 1781872732963,
          "testimonial_3_background_image": null,
          "section_heading": "More than {1,000} Creators Have Trusted Us Since We Started.",
          "testimonial_4_redirection_link": "https://www.goldweatherkingdom.com/",
          "testimonial_2_background_image": null,
          "testimonial_5_redirection_link": "https://www.topfan.com/tulsa_bite",
          "testimonial_1_content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
          "secondary_background_color": "#000000",
          "testimonial_2_stars": "5",
          "testimonial_2_name": "Julia Julia",
          "testimonial_cards": [
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_john.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "johnward",
              "name": "John Ward",
              "redirection_link": "https://www.topfan.com/johnward",
              "stars": "5",
              "content": "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_julia.jpg",
              "creator_type": "Musicians",
              "user_name": "julia-kugel",
              "name": "Julia Julia",
              "redirection_link": "https://www.juliajulia.fans/",
              "stars": "5",
              "content": "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!"
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
              "creator_type": "Food, Fitness and Wellness",
              "user_name": "katrinadarlingfriedman",
              "name": "Katrina Darling Friedman",
              "redirection_link": "https://www.topfan.com/katrinadarlingfriedman",
              "stars": "5",
              "content": "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_david.jpg",
              "creator_type": "Professionals",
              "user_name": "davidgold",
              "name": "David Gold",
              "redirection_link": "https://www.goldweatherkingdom.com/",
              "stars": "5",
              "content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_tulsa_bite.jpeg",
              "creator_type": "Creator and Influencer",
              "user_name": "tulsa_bite",
              "name": "Tulsa Bite",
              "redirection_link": "https://www.topfan.com/tulsa_bite",
              "stars": "5",
              "content": "When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_predictor.png",
              "creator_type": "Organizations",
              "user_name": "the-predictors",
              "name": "The Predictors",
              "redirection_link": "https://www.thepredictors.fans/",
              "stars": "5",
              "content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers."
            },
            {
              "background_image": null,
              "image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
              "creator_type": "Athletes",
              "user_name": "markschlereth",
              "name": "Mark Schlereth",
              "redirection_link": "https://www.markschlereth.fans/",
              "stars": "5",
              "content": "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform."
            }
          ],
          "testimonial_6_redirection_link": "https://www.thepredictors.fans/",
          "testimonial_6_user_name": "the-predictors",
          "testimonial_6_content": "ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers.",
          "heading_font_size": "medium",
          "testimonial_1_redirection_link": "https://www.topfan.com/johnward",
          "testimonial_3_stars": "5",
          "testimonial_7_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_mark_schlereth.png",
          "testimonial_1_name": "John Ward",
          "testimonial_4_content": "I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.",
          "testimonial_3_image": "https://cdn-www7.topfans.dev/TopFans/Home1780923462026_katrina.jpg",
          "theme_color": "#141515",
          "background_image": null,
          "testimonial_5_background_image": null,
          "post_text_color": "#ffffff",
          "testimonial_6_stars": "5",
          "testimonial_2_creator_type": "Musicians",
          "testimonial_4_name": "David Gold",
          "testimonial_1_creator_type": "Food, Fitness and Wellness",
          "testimonial_7_name": "Mark Schlereth",
          "testimonial_3_creator_type": "Food, Fitness and Wellness",
          "sk": "SECTION#1781872749809"
        }
      ]
    }
  }
};
